<template>
    <!-- 首页组件 -->
    <div class="homepage" id="HOMEPAGE-SWF" @click="homePageClick()">
        <!-- 主导航组件 -->
        <div class="nav">
            <div style="background:#2a2a2a;position:absolute;left:0;top:0;width:180px;height:60px;">
                <div class="logo"><img src="./logo.png"></div>
            </div>
            <div style="position:absolute;left:180px;top:0;right:0;bottom:20px;background:#2a2a2a;"></div>
            <div class="menu cl-effect-4">
                <ul>
                    <li v-for="item, index in menu" :class="{ 'active': item.active }" @click="handleMenu(index, menu)">
                        {{item.nickname}}
                        <div class="board"></div>
                    </li>
                    <!-- style="background:yellow;width:50px;height:50px;position:absolute;margin:auto;top:0;left:0;bottom:-58px;right:0;"-->
                    <i class="el-icon-d-arrow-right menu-more" v-if="menuMore" @click.stop="handleMenuMore" style="line-height:40px;transform:rotate(90deg);cursor:pointer;color:#fff;font-weight:bold;"></i>
                </ul>
            </div>
            <el-popover
                ref="qq-popover"
                placement="bottom"
                width="248"
                trigger="hover"
                :open-delay="500"
                class="">
                <section class="class-qq-popover">
                    <img src="./home_qq_contact.png">
                </section>
            </el-popover>
            <section class="class-qq-icon" v-popover:qq-popover >
                <div>
                    <img src="./qqIcon.svg">
                </div>
            </section>
            <div class="class-vip-icon" @click="handleOpenVip(true)">
                <img src="./icon-vip-svg.svg">
            </div>
            <el-popover
                ref="userinfo-popover"
                placement="bottom"
                width="250"
                trigger="click"
                class="">
                <section class="userinfo_popover">
                    <div class="avatar">
                        <img v-if="userinfo.avatarInfo == null" src="./avatar.png">
                        <img v-if="userinfo.avatarInfo" :src="userinfo.avatarInfo">
                    </div>
                    <div class="txt">
                        <div class="nickname">{{userinfo.nickname}}</div>
                        <div class="identity">{{identity.name}}</div>
                    </div>
                    <div class="user_operation">
                        <div class="item" style="display:inline-block;background:#fff;margin-right:30px;" v-for="item,index in userInfo_data" @click="handleOperation(item)">{{item}}</div>
                    </div>
                    <div class="user_export" >
                        <div style="display:inline-block;height:20px;background:#fff;line-height:20px;font-size:12px;">{{'点数:' + user_export_money}}</div>
                        <el-button type="warning" size="mini" class="user_recharge"  @click="handleRecharge(true)">充值</el-button>
                    </div>
                    <div class="limittime" v-show="isLimitTimeValid">有效期至:{{timestamp(identity.limittime)}}</div>
                    <div class="login-out">
                        <el-button type="danger" size="mini" @click="handleLoginOut">退出登录</el-button>
                    </div>
                </section>
            </el-popover>
            <section class="userinfo" v-popover:userinfo-popover >
                <div class="avatar">
                    <img v-if="userinfo.avatarInfo == null" src="./avatar.png">
                    <img v-if="userinfo.avatarInfo" :src="userinfo.avatarInfo">
                </div>
                <div class="nickname">{{userinfo.nickname}}</div>
            </section>
        </div>
        <div class="menu-more-list"  v-show="menuMoreList">
            <div class="menu-more-list-item" v-for="item, index in listMenuLast" @click="handleListMenuLast(index, listMenuLast)">
                {{item.nickname}}
            </div>
        </div>

        <!-- 侧边航组件 -->
        <div class="slidebar">
            <div class="menu cl-effect-5">
                <div :class="{ 'active': aiimage_status}">
                    <span v-show="aiimage_status" class="left-border" ></span>
                    <span class="left-icon ai"></span>
                    <span class="left-title" data-hover="AI生成" @click="handleAiImage()">AI生成</span>
                </div>
                <div :class="{ 'status': item.status ,'active': item.active}" v-for="item, index in menu_category" @click="handleMenuCategory(item, index, menu_category)">
                    <span v-show="item.active" class="left-border"></span>
                    <span class="left-icon"  :class="item.type" ></span>
                    <span class="left-title" :data-hover="item.name">{{item.name}}</span>
                </div>
                <div :class="{ 'active': package_status}">
                    <span v-show="package_status" class="left-border" ></span>
                    <span class="left-icon"  :class="left_menu_buy"></span>
                    <span class="left-title" data-hover="购买的素材" @click="handlePackage()">购买的素材</span>
                </div>
            </div>
        </div>
        <!-- 工具条组件 -->
        <div class="toolbar" v-if="!upload && !no_permission && !package_status && !aiimage_status">
            <!-- 左侧区 -->
            <div class="left">
                <!-- 标题组件 -->
                <div class="title" v-show="type == 'anim'">
                    <span class="text">动画</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'scene'">
                    <span class="text">场景</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'material'">
                    <span class="text">形象</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'prop'">
                    <span class="text">道具</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'action'">
                    <span class="text">动作</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'bgm'">
                    <span class="text">背景音乐</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'team'">
                    <span class="text">成员</span>
                    <span class="count">({{team_management_result.length}}/{{team_manager_numbers}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'template'">
                    <span class="text">模版</span>
                    <span class="count">({{total}})</span>
                </div>
                <!-- 标题组件 -->
                <div class="title"  v-show="type == 'component'">
                    <span class="text">组件</span>
                    <span class="count">({{total}})</span>
                </div>
            </div>
            <!-- 右侧区 -->
            <div class="right" >
                <!-- 搜索组件 -->
                <div class="search" v-show="dialog_button_group_1_visible && !team_management">
                    <input type="text" class="text" :placeholder="text" v-model="search_key" @keyup.enter = "handleSearch" >
                    <span class="el-icon-close button" @click="handleSearchClose" v-show="search_key.length > 0"></span>
                    <span class="icon-search button" @click="handleSearch"></span>
                </div>
                <!-- 按钮组组件 -->
                <div class="button-group" v-show="dialog_button_group_1_visible && !team_management">
                    <el-button type="success" v-if="hasManagementPermission(type)" @click="dialog_folder_create_visible = true" style="background:#7ab3f6;border-color:#7ab3f6;font-size:14px;font-family:PingFangSC-Regular;">创建文件夹</el-button>
                    <el-button type="primary" v-if="hasManagementPermission(type)" @click="handleButtonGroup1" style="background:#7ab3f6;border-color:#7ab3f6;font-size:14px;font-family:PingFangSC-Regular;"> 管理</el-button>
                    <el-button type="warning" v-if="hasCreatePermission('anim') && type == 'anim'" @click="handleCreateAnim()" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;"> 创建动画</el-button>
                    <el-dropdown v-if="hasCreatePermission('scene') && type == 'scene'" @command="handleCommand">
                        <el-button type="warning" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" > 创建场景 </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{type:'scene', action:'upload'}">上传场景</el-dropdown-item>
                            <el-dropdown-item :command="{type:'scene', action:'ai'}">AI生成</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="warning" v-if="hasCreatePermission('material') && type == 'material'" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" @click="handleUploading('material')"> 创建形象</el-button>
                    <el-dropdown v-if="hasCreatePermission('prop') && type == 'prop'" @command="handleCommand">
                        <el-button type="warning" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" > 创建道具 </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{type:'prop', action:'upload'}">上传道具</el-dropdown-item>
                            <el-dropdown-item :command="{type:'prop', action:'ai'}">AI生成</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="warning" v-if="hasCreatePermission('action') && type == 'action'" @click="handlePostCreateAction" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;"> 创建动作</el-button>
                    <el-button type="warning" v-if="hasCreatePermission('bgm') && type == 'bgm'" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" @click="handleUploading('bgm')"> 创建背景音乐</el-button>
                    <el-button type="warning" v-if="hasCreatePermission('component') && type == 'component'" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" @click="handleUploading('component')"> 创建组件</el-button>
                    <el-button type="warning" v-if="hasCreatePermission('soundeffect') && type == 'soundeffect'" style="background:#ffa225;border-color:#ffa225;font-size:14px;font-family:PingFangSC-Regular;" @click="handleUploading('soundeffect')"> 创建音效</el-button>
                </div>
                <!-- 按钮组组件 -->
                <div class="button-group" v-show="dialog_button_group_2_visible">
                    <span v-show="folder_file_data.length == 0" style="color:#fff;">请从下方选择要批量操作的内容！</span>
                    <span v-show="folder_file_data.length > 0"  style="color:#fff;">已选中 <strong>{{folder_file_data.length}}</strong> 项</span>
                    <el-button type="success" :disabled="disabledVisible" @click="handleDialogEdit('batch')"><i class="icon-folder-open"></i> 移动到...</el-button>
                    <el-button type="success" :disabled="disabledVisible" @click="handleDialogEdit('batch')" v-show="type != 'anim' && type != 'folder'"><i class="icon-magic-wand"></i> 发布</el-button>
                    <el-button type="danger" :disabled="disabledVisible" @click="handleDialogDelete('other', '', '')"><i class="icon-bin"></i> 删除</el-button>
                    <el-button @click="handleButtonGroup2"><i class="icon-x-altx-alt"></i> 取消</el-button>
                </div>
                <!-- 团队管理的添加成员按钮 -->
                <div class="button-team-managent" v-show="team_management">
                    <el-button type="primary" size="mini" 
                               :style="team_management_result.length >= team_manager_numbers ? 
                                       'background:#ccc;border-color:#ccc;height:30px;cursor:not-allowed;' : 
                                       'background:#ffa225;border-color:#ffa225;height:30px;'" 
                               :disabled="team_management_result.length >= team_manager_numbers" 
                               @click="addTeamMembers"> 
                        添加团队成员
                    </el-button>
                </div>
            </div>
        </div>
        <!-- AI生图组件 -->
        <div class="ai-image" v-if="showAiImageComponent">
            <!-- 素材包详情组件 -->
            <AiImage 
                v-if="showAiImageComponent" 
                :token="token"
                style="margin-top: 10px;" 
                @navigate-to-sdui="handleNavigateToSdui"
            />
        </div>
        
        <!-- 主内容 -->
        <div class="main" v-if="!showAiImageComponent && !upload && !no_permission && !package_status && !team_management && !aiimage_status">
            <!-- 加载组件 -->
            <div v-loading="loading" element-loading-text="数据加载中" class="loading" v-show="loading"></div>
            <!-- 主内容内侧 -->
            <div class="inner">
                <!-- 面包屑组件 -->
                <div class="breadcrumb">
                    <span v-show="breadcrumb.length > 1"
                        v-for="item, index in breadcrumb"
                        @click="handleTargetNav(index, item.folder_id)">{{'/ ' + item.name}}</span>
                </div>
                <!-- 列表组件 -->
                <div class="list cl-effect-8" v-show="!no_result">
                    <div v-if="type != 'action'" v-for="item, index in data" :class="homeListItemWH" @mouseover="handleFolderGroupShow" @mouseout="handleFolderGroupHide" class="item">
                        <el-checkbox-group v-model="folder_file_data">
                            <el-checkbox class="checkbox"
                            v-show="dialog_folder_group_selected_visible"
                            :label="item.id"
                            @click="change($event)"
                            size="large"></el-checkbox>
                        </el-checkbox-group>
                        <div class="pic folder" :class="homeListItemWH" @click="handleTarget(item.type, item.title, item.id, item.proportion, item)" v-if="item.type == 'folder'">
                            <img class="folder-img" v-if="type != 'material' && type != 'prop'" src="./folder.png">
                            <img class="folder-material" v-if="type == 'material' || type == 'prop' " src="./folder.png">
                            <div class="folder-group" v-show="dialog_button_group_1_visible">
                                <el-tooltip effect="dark" content="修改文件夹信息" placement="top-start" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="icon-home_edit" @click.stop="handleDialogEdit('default', item)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="删除文件夹" placement="top" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="el-icon-delete" @click.stop="handleDialogDelete(item.type, item.title, item.id)"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="pic" :class="homeListItemWH" @click="handleTarget(item.type, item.title, item.id, item.proportion, item)" v-if="item.type != 'folder'">
                            <div class="duration" v-if="item.type == 'anim' || item.type == 'template'">{{item.extdata?timestamp1(item.extdata.duration):'00:00'}}</div>
                            <img class="item-img" v-if="item.type == 'anim' || item.type == 'scene' || item.type == 'template' || item.type == 'component'" :src="item.preview" v-show="item.preview">
                            <div class="material-img-con">
                                <img class="material-img" v-if="item.type == 'material' || item.type == 'prop' " :src="item.preview" v-show="item.preview">
                                <img class="material-img" v-if="item.type == 'bgm'" src="./music.png">
                                <img class="material-img-vertical-default"  src="./conver_scene_horizontal.png"  v-if="item.type == 'anim' || item.type == 'scene'" v-show="!item.preview">
                                <img class="material-img-horizontal-default"  src="./conver_material_vertical.png"  v-if="item.type == 'material' || item.type == 'prop'" v-show="!item.preview">
                            </div>
                            <div class="folder-group" v-show="dialog_button_group_1_visible">
                                <el-tooltip effect="dark" content="修改标题和简介" placement="top-start" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="icon-home_edit" @click.stop="handleDialogEdit('default', item)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="创建副本" placement="top" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)" v-show="type == 'anim' || type == 'scene' || type == 'action' || type == 'template' || type == 'component'">
                                    <i class="icon-home_aadd" style="color:#fff;" @click.stop="handleFolderGroupCopy(item.id)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="另存为模版" placement="top" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)" v-show="type == 'anim'">
                                    <i class="icon-home_template_save" style="color:#fff;" @click.stop="handleTemplateSave(item.id)"></i>
                                </el-tooltip>
                                <!-- 形象重新上传 || self_oid == item.creator_user_id -->
                                <el-tooltip effect="dark" content="重新上传" placement="top-end" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)" v-show="type == 'material'">
                                    <i class="icon-home_uploading"  @click.stop="handleAfreshUploading(item)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="删除" placement="top-end" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="el-icon-delete" @click.stop="handleDialogDelete(item.type, item.title, item.id)"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="name">{{(item.type == 'material' || item.type == 'prop')?(item.title.length>10?item.title.substring(0, 10) + '...':item.title):item.title}}</div>
                        <div class="name" v-if="item.type != 'folder'">作者: &nbsp {{item.creator}}</div>
                        <div class="name" v-if="item.type == 'folder'">&nbsp </div>
                        <div class="date" :class="homeDateLeft">{{item.type != 'folder' ? timestamp(item.updateTime) : timestamp(item.createTime)}}</div>
                    </div>
                    <!--动作的单独样式  -->
                    <div v-if="type == 'action'" class="list-action" v-for="item, index in data" @mouseover="handleFolderGroupShow" @mouseout="handleFolderGroupHide" @click="handleTarget(item.type, item.title, item.id, item.proportion, item)" style="width:260px;height:80px;margin-right:20px;margin-bottom:20px;cursor:pointer;position:relative;display:block;float:left;background:#303030;">
                        <div class="top" style="position:relative;top:0;left:0;right:0;height:40px;background:#626262;">
                            <div v-if="item.type == 'folder'">
                                <img style="position:relative;top:5px;left:8px;height:30px;width:40px;" src="./action-folder.png">
                                <div style="position:absolute;top:13px;bottom:10px;right:5px;left:60px;color:#e2e2e2;">{{item.title.length>13?item.title.substring(0,13)+'...':item.title}}</div>
                            </div>
                            <div v-if="item.type != 'folder'">
                                <div style="position:absolute;top:13px;bottom:10px;right:5px;left:8px;color:#e2e2e2;">{{item.title.length>13?item.title.substring(0,13)+'...':item.title}}</div>
                                <div class="group" style="position:absolute;top:13px;right:5px;color:#2f2f2f;-webkit-transform:scale(0.8);" v-if="item.extdata && item.extdata.movable !== null">
                                    <i class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                                    <i class="icon-action_circulation" v-if="item.extdata.looped && !item.extdata.movable"></i>
                                    <i class="icon-action_time" v-if="!item.extdata.movable || !item.extdata.looped"></i>
                                    <span  style="color:#e2e2e2;" v-if="!item.extdata.movable || !item.extdata.looped">{{item.extdata.duration?item.extdata.duration.toFixed(2)+'秒':''}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom" style="position:relative;bottom:0;left:0;right:0;height:40px;">
                            <div class="name" v-if="item.type != 'folder'">作者: &nbsp {{item.creator}}</div>
                            <div class="name" v-if="item.type == 'folder'">&nbsp </div>
                            <div class="date">{{item.type != 'folder' ? timestamp(item.updateTime) : timestamp(item.createTime)}}</div>

                            <div class="folder-group" v-if="item.type == 'folder'" v-show="dialog_button_group_1_visible">
                                <el-tooltip effect="dark" content="修改文件夹信息" placement="top-start" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="icon-home_edit" @click.stop="handleDialogEdit('default', item)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="删除文件夹" placement="top" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="el-icon-delete" @click.stop="handleDialogDelete(item.type, item.title, item.id)"></i>
                                </el-tooltip>
                            </div>
                            <div class="folder-group" v-if="item.type != 'folder'" v-show="dialog_button_group_1_visible">
                                <el-tooltip effect="dark" content="修改标题和简介" placement="top-start" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="icon-home_edit" @click.stop="handleDialogEdit('default', item)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="创建副本" placement="top" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="icon-home_aadd" style="color:#fff;font-size:28px;" @click.stop="handleFolderGroupCopy(item.id)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="删除" placement="top-end" v-if="permission == 2 || (permission == 1 && self_oid == item.creator_user_id)">
                                    <i class="el-icon-delete" @click.stop="handleDialogDelete(item.type, item.title, item.id)"></i>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no_results" v-show="no_result">
                    <div class="pic">
                        <img src="./no_result.png">
                    </div>
                    <div class="text">{{category_txt}}暂时还没有内容呦~^-^~</div>
                </div>
                <!-- 分页组件 -->
                <div class="pagination" v-show="data.length > 0">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="current_page"
                    :page-sizes="[20, 50]"
                    :page-size="page_size"
                    :pager-count="5"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    size="small">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 团队管理的界面 -->
        <div class="team_management"  v-if="team_management" v-show="team_management && tab_team_status == '0' && identity.permission.team == '2'">
            <!-- 加载组件 :highlight-current-row='false'-->
            <div v-loading="loading" element-loading-text="数据加载中" class="loading" v-show="loading"></div>
            <el-table class="team_management_table" :data="team_management_result" border style="width: 96%;left:20px;" max-height="750" :row-style="team_managent_row_style" :header-cell-style="team_managent_row_style" >
                <el-table-column label="成员昵称" width="200" >
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.nickname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="成员账号" width="200">
                    <template slot-scope="scope">
                        <div style="margin-left: 10px">{{ scope.row.username}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="角色" fit>
                    <template slot-scope="scope">
                        <span slot="reference" class="name-wrapper" v-for="item,index in scope.row.permissions" >
                            <el-tag size="medium" color="white" style="margin-bottom:10px;border-color:#E8E8E8;color:#e2e2e2;background:#303030;;">{{classMap[item.type] + '(' + team_select[item.permission] +')'}}</el-tag>
                            <span>&nbsp</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="225">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" style="margin-left:40px;background:#7AB3F6;color:white" @click="handleTeamMemberEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="memberDelete(scope.$index)">删除</el-button>
                       <el-dialog title="删除" :visible.sync="centerDialogVisible" width="30%" center>
                        <span>确定要删除此成员吗?</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="centerDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="handleTeamMemberDelete()">确 定</el-button>
                        </span>
                        </el-dialog>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加和编辑的界面 -->
            <div class="team_add_edit" style="background:#303030;" v-show="team_add_edit && tab_team_status == '0' && type == 'team'">
              <div class="top">
                  <el-button class="back_btn" type="text" icon="el-icon-arrow-left" style="color:#fff;" @click="hanadleBack">返回</el-button>
                  <div class="title" style="color:#fff;"><p class="p">{{team_add_edit_title}}团队成员</p></div>
              </div>
              <div style="position:absolute;left:0;top:800px;right:0;bottom:0px;background:#303030;z-index:100;"></div>
              <div style="position:absolute;left:96%;top:60px;right:0;bottom:0px;background:#303030;z-index:100;"></div>
              <div class="team_management_content">
                  <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="成员账号:" prop="name">
                           <el-input v-model="ruleForm.name" placeholder="请输入成员专业版账号" v-if="team_add_edit_title == '添加'" @blur="teamTitleInput"></el-input>
                           <div v-if="team_add_edit_title == '编辑'" style="color:#e2e2e2;">{{team_member_info.username}}</div>
                        </el-form-item>
                        <el-form-item label="成员昵称:" prop="name">
                           <div v-show="team_member_exist" style="color:#e2e2e2;">{{team_member_name}}</div>
                           <div v-show="!team_member_exist" style="color:red">此账号未注册!</div>
                           <div v-if="team_add_edit_title == '编辑'" style="color:#e2e2e2;">{{team_member_info.nickname}}</div>
                        </el-form-item>
                        <el-form-item label="成员角色:" prop="name">
                            <el-checkbox-group v-model="team_management_check_group">
                                <div>
                                    <el-checkbox label="动画" name="type" @change="handleAnimCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_0" @change="hanadleAnimSelect"  v-show="team_class_member[0].checked" placeholder="制作人员" size="mini" style="margin-left:10px;">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[0].permission == '0'" v-model="team_select_0" @change="hanadleAnimSelect"  v-show="team_class_member[0].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[0].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[0].checked && team_class_member[0].permission != '0' && team_class_member[0].permission != '2')" v-model="team_select_0" @change="hanadleAnimSelect"  v-show="team_class_member[0].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[0].permission == '2' " v-model="team_select_0" @change="hanadleAnimSelect"  v-show="team_class_member[0].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="形象" name="type" @change="handleMaterialCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_1" @change="hanadleMaterialSelect" v-show="team_class_member[1].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[1].permission == '0'" v-model="team_select_1" @change="hanadleMaterialSelect"  v-show="team_class_member[1].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[1].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[1].checked && team_class_member[1].permission != '0' && team_class_member[1].permission != '2')" v-model="team_select_1" @change="hanadleMaterialSelect"  v-show="team_class_member[1].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[1].permission == '2'" v-model="team_select_1" @change="hanadleMaterialSelect"  v-show="team_class_member[1].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="动作" name="type" @change="handleActionCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_2" @change="hanadleActionSelect" v-show="team_class_member[2].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[2].permission == '0'" v-model="team_select_2" @change="hanadleActionSelect"  v-show="team_class_member[2].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[2].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[2].checked && team_class_member[2].permission != '0' && team_class_member[2].permission != '2')" v-model="team_select_2" @change="hanadleActionSelect"  v-show="team_class_member[2].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[2].permission == '2'" v-model="team_select_2" @change="hanadleActionSelect"  v-show="team_class_member[2].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="道具" name="type" @change="handlePropCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_3" @change="hanadlePropSelect" v-show="team_class_member[3].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[3].permission == '0'" v-model="team_select_3" @change="hanadlePropSelect"  v-show="team_class_member[3].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[3].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[3].checked && team_class_member[3].permission != '0' && team_class_member[3].permission != '2')" v-model="team_select_3" @change="hanadlePropSelect"  v-show="team_class_member[3].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[3].permission == '2'" v-model="team_select_3" @change="hanadlePropSelect"  v-show="team_class_member[3].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="场景" name="type" @change="handleSceneCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_4" @change="hanadleSceneSelect" v-show="team_class_member[4].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[4].permission == '0'" v-model="team_select_4" @change="hanadleSceneSelect"  v-show="team_class_member[4].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[4].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[4].checked && team_class_member[4].permission != '0' && team_class_member[4].permission != '2')" v-model="team_select_4" @change="hanadleSceneSelect"  v-show="team_class_member[4].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[4].permission == '2'" v-model="team_select_4" @change="hanadleSceneSelect"  v-show="team_class_member[4].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="背景音" name="type" @change="handleBgmCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_5" @change="hanadleBgmSelect" v-show="team_class_member[5].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[5].permission == '0'" v-model="team_select_5" @change="hanadleBgmSelect"  v-show="team_class_member[5].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[5].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[5].checked && team_class_member[5].permission != '0' && team_class_member[5].permission != '2')" v-model="team_select_5" @change="hanadleBgmSelect"  v-show="team_class_member[5].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[5].permission == '2'" v-model="team_select_5" @change="hanadleBgmSelect"  v-show="team_class_member[5].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox  label="模版" name="type" @change="handleTemplateCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_6" @change="hanadleTemplateSelect" v-show="team_class_member[6].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[6].permission == '0'" v-model="team_select_6" @change="hanadleTemplateSelect"  v-show="team_class_member[6].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[6].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[6].checked && team_class_member[6].permission != '0' && team_class_member[6].permission != '2')" v-model="team_select_6" @change="hanadleTemplateSelect"  v-show="team_class_member[6].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[6].permission == '2'" v-model="team_select_6" @change="hanadleTemplateSelect"  v-show="team_class_member[6].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-checkbox label="组件" name="type" @change="handleComponentCheckbox"></el-checkbox>
                                    <el-select v-if="team_add_edit_title == '添加'" v-model="team_select_7" @change="hanadleComponentSelect"  v-show="team_class_member[7].checked" placeholder="制作人员" size="mini" style="margin-left:10px;">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[7].permission == '0'" v-model="team_select_7" @change="hanadleComponentSelect"  v-show="team_class_member[7].checked" placeholder="查看人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[7].permission == '1' || (team_add_edit_title == '编辑' && team_class_member[7].checked && team_class_member[7].permission != '0' && team_class_member[7].permission != '2')" v-model="team_select_7" @change="hanadleComponentSelect"  v-show="team_class_member[7].checked" placeholder="制作人员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                    <el-select v-if="team_add_edit_title == '编辑' && team_class_member[7].permission == '2' " v-model="team_select_7" @change="hanadleComponentSelect"  v-show="team_class_member[7].checked" placeholder="管理员" size="mini" style="margin-left:10px">
                                        <el-option label="查看人员" value="0"></el-option>
                                        <el-option label="制作人员" value="1"></el-option>
                                        <el-option label="管理员" value="2"></el-option>
                                    </el-select>
                                </div>
                            </el-checkbox-group>
                        </el-form-item>
                  </el-form>
              </div>
              <!-- 添加和编辑的保存按钮 -->
              <div class="team_management_save">
                   <!-- 默认不能点击的保存按钮 -->
                   <el-button class="team_save_btn" act type="warning" :disabled="disabled = true" v-show="!team_saveBtn_status" style="background:lightGray;border-color:lightGray;width:220px"> 保存</el-button>
                   <el-button class="team_save_btn" act type="warning" v-show="team_saveBtn_status" style="background:#ffa225;border-color:#ffa225;width:220px" @click="team_management_save"> 保存</el-button>
              </div>
            </div>
        <div class="package_list_toorbar" v-if="package_status && !package_detail_status">
            <div class="package_list_toorbar_left">我购买的素材({{package_list_data.length}})</div>
            <div class="package_list_toorbar_right">
                <!-- 搜索组件 -->
                <div class="search">
                    <input type="text" class="text" :placeholder="text" v-model="search_key_package" @keyup.enter = "handleSearchPackage">
                    <span class="el-icon-close button" @click="handleSearchClosePackage" v-show="search_key_package.length > 0"></span>
                    <span class="icon-search button" @click="handleSearchPackage"></span>
                </div>
            </div>
        </div>
        <div @click="handleGoBack()" class="package_back" style="background:#303030;color:#fff;" v-if="package_detail_status">< 返回</div>
        <div class="package" v-show="package_status">
            <div class="package_list"style="position: static;" v-if="!package_detail_status && !no_result">
                <div class="package_list_data">
                    <div class="item" v-for="item, index in package_list_data" @click="handlePackageDetail(item)">
                        <div class="pic">
                            <img src="./folder.png">
                        </div>
                        <div class="title">{{item.title}}</div>
                    </div>
                </div>
            </div>
            <!--无结果页-->
            <div class="no_results" v-if="no_result" style="padding-top:55px;">
                <div class="pic">
                    <img src="./no_result.png">
                </div>
                <div class="text">{{category_txt}}暂时还没有购买东西呦~^-^~</div>
            </div>
            <!-- 分页组件 -->
            <div class="pagination" v-show="package_list_data.length > 0" v-if="!package_detail_status">
                <el-pagination
                @size-change="handleSizeChangePack"
                @current-change="handleCurrentChangePack"
                :current-page="current_page_pack"
                :page-sizes="[20, 50]"
                :page-size="page_size_pack"
                :total="total_pack"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                size="small">
                </el-pagination>
            </div>
            <!-- 素材包详情组件 -->
            <PackageDetail 
                v-if="package_detail_status && current_package_id" 
                :package-id="current_package_id" 
                :token="token"
                style="margin-top: 10px;" 
            />
        </div>
        <upload :token="token" :type="type" :teamid="tab_team_id"  :handle="handleC" :folderid="folder_id" :uploading="home_uploading" v-if="upload"></upload>
        <EditUserInfo :userInfoShow="userInfoShow" :title="userInfoTitle" :user_icon="userinfo.avatarInfo"  @showUserInfo="handleUserInfo" @changeHomePageUserIcon="changeHomePageUserIcon"></EditUserInfo>
        <!-- 充值组件 -->
        <Recharge :visible.sync="pay_money_status" @showRecharge="handleRecharge" @userCoupon="handUserCoupon"></Recharge>
        <VipMember :visible.sync="vip_dialog_visible" :identity="identity" :teamId="tab_team_id" @show-qrcode="handleQrcode" />
        <div v-if="no_permission" class="no_permission" @click="handleOpenVip(true)">
            <template v-if="type === 'material' || type === 'action'">
                对不起您没有该权益，请购买专业版
            </template>
            <template v-else-if="type === 'team'">
                对不起您没有该权益，请购买企业版
            </template>
            <template v-else>
                对不起您没有该权益，请购买标准版
            </template>
        </div>
        <!-- 弹窗组件 -> 创建文件夹 -->
        <el-dialog title="创建文件夹" class="dialog" :visible.sync="dialog_folder_create_visible" size="tiny">
            <el-form :model="form" class="body">
                <el-form-item label="文件夹名称" :label-width="formLabelWidth">
                    <el-input v-model="form.title" auto-complete="off" autofocus :disabled="folder_creat_input_disabled"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleBtnCancel">取 消</el-button>
                <el-button type="primary" @click="handleCreateFolder">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 弹窗组件 -> 修改标题和简介 -->
        <el-dialog :title="form_all_edit_visible ? '修改标题和简介' : '移动到'" class="dialog" :visible.sync="dialog_edit_visible">
            <el-form :model="form_all_edit" class="body" v-show="form_all_edit_visible">
                <el-form-item label="所在文件夹" :label-width="formLabelWidth">
                    <div class="el-tree" @click="clickFieldChange" v-show="!clickFieldChangeStatus">
                        <div class="el-tree-node__content" style="padding-left: 0px;">
                            <span class="el-tree-node__expand-icon"></span><!---->
                            <span class="el-tree-node__label">{{ 0 < breadcrumb.length ? breadcrumb[breadcrumb.length-1].name : '' }}</span>
                        </div>
                    </div>
                    <el-tree  v-show="clickFieldChangeStatus" :data="form_all_edit.directory" :props="form_all_edit.defaultProps" :highlight-current="true" node-key="id"  :default-checked-keys="[folder_id]" :current-node-key="folder_id" :default-expanded-keys="[from_folder_id]" @node-click="handleNodeClick"></el-tree>
                </el-form-item>
                <el-form-item label="名称" :label-width="formLabelWidth">
                    <el-input v-model="form_all_edit.title" auto-complete="off" autofocus :disabled="folder_name_input_disabled"></el-input><!--@input="onSubmit" @blur="onSubmit" @keyup.enter = "onSubmit"-->
                </el-form-item>
                <el-form-item label="简介" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form_all_edit.intro"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="form_all_edit" class="body" v-show="form_all_edit_batch_visible">
                <el-form-item label="移动到文件夹" :label-width="formLabelWidth">
                    <el-tree :data="form_all_edit.directory" :props="form_all_edit.defaultProps" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleBtnCancel">取 消</el-button>
                <el-button type="primary" @click="handleUpdateFolder(form_all_edit_visible ? 'default' : 'batch')">{{form_all_edit_visible ? '确 定' : '移动到'}}</el-button>
            </div>
        </el-dialog>
        <!-- 弹窗组件 -> 删除文件及文件夹 -->
        <el-dialog title="提示" class="dialog dialog-delete" :visible.sync="dialog_delete_visible" size="tiny">
            <div class="text" v-show="folder_file_type == 'folder'">确定要 <span>删除</span> 文件夹 <span>{{folder_file_title}}</span> 吗？这是一个文件夹，会删除其下所有数据！</div>
            <div class="text" v-show="folder_file_type == 'anim' ||
                                    folder_file_type == 'scene' ||
                                    folder_file_type == 'material' ||
                                    folder_file_type == 'prop' ||
                                    folder_file_type == 'action' ||
                                    folder_file_type == 'bgm' ||
                                    folder_file_type == 'template' ||
                                    folder_file_type == 'component' ">确定要 <span>删除</span> 文件 <span>{{folder_file_title}}</span> 吗？</div>
            <div class="text" v-show="folder_file_type == 'other'">确定要 <span>删除</span> 选中的 <span>{{folder_file_data.length}}条</span> 数据吗？</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleBtnCancel">取 消</el-button>
                <el-button type="primary" @click="handleFolderDelete">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 音乐播放器 -->
        <el-dialog title="" v-model="dialog_bgm_listen_visible" :visible.sync="dialog_bgm_listen_visible">
            <div class="bgm_info">
                <div class="pic">
                    <img src="./music.png">
                </div>
                <div class="bgm_title">{{bgm_title}}</div>
                <div class="bgm_copyright">{{bgm_copyright}}</div>
            </div>
            <div class="bgm_play">
                <i @click="handleBgmPlay" class="icon-play" v-show="play_status"></i>
                <i @click="handleBgmPause" class="icon-pause" v-show="!play_status"></i>
                <el-slider v-model="value1" :max="max_time" :show-tooltip ="false" @change="changeBgmTime"></el-slider>
                <div class="time">{{current}} / {{total_time}}</div>
            </div>
            <video :src="audio_src" id="homepage_audio" style="display: none;"></video>
        </el-dialog>
        <el-dialog :title="playerScriptTitle" width="65%" center top="80px" :visible.sync="dialog_video_play_visible" v-model="dialog_video_play_visible">
            <div class="player" id="player">
                <div class='line' />
                <div class='playerContainer'>
                    <flash-swf :attributes="attr1" :flashvars="flashvars1"></flash-swf>
                </div>
                <div class='line' />
            </div>
        </el-dialog>
        <!-- 动画正在被编辑的弹窗组件 -->
        <el-dialog title="提示" class="dialog dialog-delete" :visible.sync="dialog_edit_anim"  center>
            <span>{{dialog_edit_anim_msg}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog_edit_anim = false">取 消</el-button>
                <el-button type="primary" @click="checkEditingAnim()">查 看</el-button>
            </span>
        </el-dialog>
        <!-- Psocket 组件 -->
        <psocket :attributes="attributes" :flashvars="flashvars"  v-if="platform == 'qt'"></psocket>
        <SDUi 
            :visible.sync="sduiVisible"
            :type="sduiType"
            :teamId="sduiTeamId"
            :folderId="sduiFolderId"
            :workflowId="sduiWorkflowId"
        ></SDUi>
        <MediaUpload
            :visible.sync="mediaUploadVisible"
            :type="sduiType"
            :teamId="sduiTeamId"
            :folderId="sduiFolderId"
            @refresh="refreshResourceList"
        ></MediaUpload>
    </div>
</template>
<script>
    // Psocket 组件
    import Psocket from '@/components/Flash/PSocket'
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    // SceneSwf 组件
    import FlashSwf from '@/components/Flash/FlashSwf'
    // 上传组件
    import Upload from '@/components/Upload/Upload'
    import MediaUpload from '@/components/Upload/MediaUpload'
    // 充值组件
    import Recharge from '@/components/Recharge/Recharge'
    // 编辑资料
    import EditUserInfo from '@/components/EditUserInfo/EditUserInfo'
    import EUY from '@/common/scripts/euy'
    import VipMember from '@/components/VipMember/VipMember.vue'
    import SDUi from '@/components/Ai/SDUi'
    import PackageDetail from '@/components/PackageDetail/PackageDetail.vue'
    import AiImage from '@/components/AiImage/AiImage.vue'
    export default {
        // 组件
        components: {
            Psocket,
            FlashSwf,
            Upload,
            MediaUpload,
            Recharge,
            EditUserInfo,
            VipMember,
            SDUi,
            PackageDetail,
            AiImage,
        },
        // 计算
        computed: {
            // 获取当前团队的权限信息
            currentTeamPermissions() {
                if (this.tab_team_status == 0) {
                    // "我的" 拥有所有权限
                    return { material: 2, prop: 2, action: 2, bgm: 2, anim: 2, scene: 2, component: 2, soundeffect: 2 }
                } else {
                    // 团队权限从当前选中的团队获取
                    let currentTeam = this.menu.find(team => team.active)
                    return currentTeam ? (currentTeam.permissions || {}) : {}
                }
            },
            // 搜索类型
            text () {
                // 判断状态是团队还是我的. 1为我的
                let search_str = 0 < this.tab_team_status ?  '/作者昵称' : '' ;
                switch (this.type) {
                    // 动画
                    case 'anim':
                        return '请输入动画名称'+search_str
                        break
                    // 场景
                    case 'scene':
                        return '请输入场景名称'+search_str
                        break
                    // 形象
                    case 'material':
                        return '请输入形象名称'+search_str
                        break
                    // 道具
                    case 'prop':
                        return '请输入道具名称'+search_str
                        break
                    // 动作
                    case 'action':
                        return '请输入动作名称'+search_str
                        break
                    // 背景音乐
                    case 'bgm':
                        return '请输入背景音乐名称'+search_str
                        break
                    // 组件
                    case 'component':
                        return '请输入组件名称'+search_str
                        break
                    // 音效
                    case 'soundeffect':
                        return '请输入音效名称'+search_str
                        break
                    //我购买的
                    case 'purchased':
                        return '请输入素材名称'+search_str
                        break
                    // 默认动画
                    default:
                        return '请输入动画名称'+search_str
                }
            },

            // 按钮状态
            disabledVisible ()
            {
                if (this.folder_file_data.length > 0) {
                    return false
                } else {
                    return true
                }
            },

            listenToken ()
            {
                if(this.token != ''){
                    return this.token
                }
            },

            // 首页列表的宽高
            homeListItemWH(){
                  // 动画 / 场景 / 模版 / 组件
                if(this.type == 'anim' || this.type == 'template' || this.type == 'scene' || this.type == 'component'){
                    return 'anim-'
                }
                 // 形象 / 道具
                else if(this.type == 'prop' || this.type == 'material'){
                    return 'material-'
                }
                 // 动作
                else if(this.type == 'action'){
                    return 'action-'
                } // 背景音
                else if(this.type == 'bgm'){
                    return 'bgm-'
                }

            },

            homeDateLeft(){
                // 形象 / 道具
                if(this.type == 'prop' || 'material'){
                    return 'date-material'
                }
                 // 动作
                else if(this.type == 'action'){
                    return 'date-action'
                } // 背景音
                else if(this.type == 'bgm'){
                    return 'date-bgm'
                }
            },

            isLimitTimeValid() {
                return this.identity.limittime != 0 && this.identity.limittime > Math.floor(Date.now() / 1000);
            },
        },

        data () {
            return {
                platform: this.$route.query.platform,
                upload: false,
                showAiImageComponent: false,
                list_data: [],
                menu: [
                ],
                permission: 2,
                // -------------------------------------------------- [ 基础数据 ] --------------------------------------------------
                // token
                token: '',
                // 加载状态
                loading: false,
                // -------------------------------------------------- [ 面包屑数据 ] --------------------------------------------------
                // 面包屑
                breadcrumb: [
                ],
                // -------------------------------------------------- [ 侧边栏数据 ] --------------------------------------------------
                // 侧边栏
                menu_category: [
                    { name: '动画', type: 'anim', active: false },
                    { name: '模版', type: 'template',active: false },
                    { name: '场景', type: 'scene',active: false },
                    { name: '形象', type: 'material', active: false },
                    { name: '道具', type: 'prop', active: false },
                    { name: '动作', type: 'action', active: false },
                    { name: '组件', type: 'component',active: false },
                    { name: '背景音乐', type: 'bgm', active: false },
                ],
                // -------------------------------------------------- [ 列表数据 ] --------------------------------------------------
                // 列表
                data: [],
                // 文件夹及文件
                folder_file_data: [],
                folder_file_id: '',
                folder_file_title: '',
                folder_file_type: '',
                clickFieldChangeStatus : false,
                // -------------------------------------------------- [ 状态数据 ] --------------------------------------------------
                dialog_folder_group_visible: false,
                dialog_button_group_1_visible: true,
                dialog_button_group_2_visible: false,
                dialog_folder_group_selected_visible: false,
                dialog_file_create_visible: false,
                dialog_folder_create_visible: false,
                dialog_delete_visible: false,
                dialog_edit_visible: false,
                // -------------------------------------------------- [ 表单数据 ] --------------------------------------------------
                // 表单数据
                form: {
                    title: '',
                },
                // 文件
                form_all_edit: {
                    parent_id: '',
                    directory: [],
                    defaultProps: {
                        children: 'children',
                        label: 'label'
                    },
                    title: '',
                    intro: ''
                },
                form_all_edit_visible: false,
                form_all_edit_batch: {
                    directory: '',
                },
                form_all_edit_batch_visible: false,
                formLabelWidth: '120px',
                form_create_anim: {
                    id: '',
                    title: '',
                    proportion: '16:9'
                },
                // -------------------------------------------------- [ 分页数据 ] --------------------------------------------------
                // 数据状态
                type: 'anim',
                folder_id: '',
                team_id: '',
                tab_team_id: '',
                total: 0,
                page_size: 20,
                current_page: 1,
                search_key: '',
                from_folder_id: '',
                tab_team_status: 0,
                // -------------------------------------------------- [ FLASH ] --------------------------------------------------
                flashvars: {
                    module: HOMEPAGE_NAME,
                },
                attributes: {
                    id: HOMEPAGE_NAME + '-PSOCKET'
                },
                attr1: {
                    id: 'PLAYER-SWF',
                    height: '100%',
                },
                flashvars1: {
                    module: PLAYER_NAME,
                    assetsUrl: process.env.MOVIE_PLAYER_ASSETS_SWF,
                },
                playerScriptId: "",
                playerScriptTitle: "",
                // -------------------------------------------------- [ 用户数据 ] --------------------------------------------------
                // 用户信息
                userinfo: {
                    nickname: '',
                    avatarInfo: ''
                },
                // 版本信息
                identity: {
                    name: '',
                    viplevel: 0,
                    limittime: 0,
                    permission:'',
                },
                // 列表为空默认图是否展示
                no_result: false,
                category_txt: '动画',
                dialog_bgm_listen_visible: false,
                play_status: false,
                value1: 0,
                total_time: '00:00',
                bgm_title:  '',
                bgm_copyright: '',
                audio_src: '',
                intervalid1: null,
                current: '00: 00',
                max_time: 0,
                dialog_video_play_visible: false,
                menuLength: '',
                menuNum: '',
                listMenuShow: [],
                listMenuAll: [],
                listMenuLast: [],
                menuMore: false,
                menuMoreList: false,
                self_oid: '',
                no_permission: false,
                package_status: false,
                package_detail_status: false,
                aiimage_status: false,
                current_package_id: null,
                activeName: ['1','2','3','4'],
                package_list_data: [],
                search_key_package: '',
                package_detail_data_scene: [],
                package_detail_data_material: [],
                package_detail_data_prop: [],
                package_detail_data_bgm: [],
                package_detail_data_action: [],
                current_page_pack: 1,
                page_size_pack: 20,
                total_pack: 0,
                // -------------------------------------------------- [ 团队管理相关 ] --------------------------------------------------
                // 团队管理的标记
                team_management:false,
                team_management_result:[],
                team_manager_numbers:0,
                //
                classMap:{'anim':'动画',
                          'scene':'场景',
                          'material':'形象',
                          'prop':'道具',
                          'action':'动作',
                          'bgm':'背景音',
                          'template':'模版',
                          'component':'组件',
                          },
                // 编辑和添加
                team_add_edit:false,
                team_add_edit_title:'',
                ruleForm: {
                   name: '',
                   type:'',
                   region:'',
                  },
                  form: {
                    name: '',
                    region: '',
                    delivery: false,
                    type: [],
                    },
                // 添加团队成员的昵称
                team_member_name:'',
                // 是否查询到要添加的团队成员信息,默认存在
                team_member_exist:true,
                team_checked:true,
                // 需要添加的成员
                team_member_id:'',
                team_class_member:[ {'name':'动画', 'type':'anim', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'形象','type':'material', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'动作','type':'action', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'道具','type':'prop', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'场景','type':'scene', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'背景音','type':'bgm', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'模版','type':'template', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                    {'name':'组件','type':'component', 'checked':false, 'select':'', 'default':'1', 'permission':''},
                                  ],
                team_select:['查看人员','制作人员','管理员',],
                team_select_0:['查看人员','制作人员','管理员',],
                team_select_1:['查看人员','制作人员','管理员',],
                team_select_2:['查看人员','制作人员','管理员',],
                team_select_3:['查看人员','制作人员','管理员',],
                team_select_4:['查看人员','制作人员','管理员',],
                team_select_5:['查看人员','制作人员','管理员',],
                team_select_6:['查看人员','制作人员','管理员',],
                team_select_7:['查看人员','制作人员','管理员',],    
                // 勾选的多选框
                team_management_check_group:[],
                // 编辑时默认的权限
                team_management_perms_group:[],
                // 编辑的团队成员信息
                team_member_info:{userId:'',nickname:'',username:''},
                // 默认保存按钮不能点击
                team_saveBtn_status:false,
                // 删除对话框的显示
                centerDialogVisible:false,
                // 删除的下标
                deleteIndex:'',
                // 点击enter键的标记
                touch_down_enter:false,
                // 修改名称的输入框
                folder_name_input_disabled:false,
                // 创建文件夹
                folder_creat_input_disabled:false,
                //
                menu_category_select_index:0,
                // 形象重新上传
                home_uploading:'',
                // 上传点击返回
                home_uploading_back:false,
                // 打开动画的item
                home_openAnim_item:'',
                // 是否显示动画正在编辑的提示弹框
                dialog_edit_anim:false,
                // 正在编辑动画的提示
                dialog_edit_anim_msg:'',
                team_managent_row_style:{'color':'#fff','background':'#303030',},
                left_menu_buy:"buy",
                userInfo_data:['编辑资料', '修改密码'],
                // 导出劵
                user_export_money:'0',
                // 显示充值组件
                pay_money_status:false,
                // 保存为模版的id
                home_template_save_id:'',
                //
                userInfoShow:false,
                //
                userInfoTitle:'',
                vip_dialog_visible: false,
                sduiVisible: false,
                sduiType: '',
                sduiTeamId: '',
                sduiFolderId: '',
                sduiWorkflowId: '',
                mediaUploadVisible: false,
            }
        },

        created ()
         {
            let component = this

            document.onkeydown = function (e){
                // console.log('document.onkeydown ======= >' + component.form_all_edit_visible)
                if(component.form_all_edit_visible){// 修改文件夹／动画名称
                    let key = window.event.keyCode
                    if(key == 13){
                        component.folder_name_input_disabled = true
                        component.touch_down_enter = true
                        component.handleUpdateFolder('default')
                        component.touch_down_enter = false
                    }
                //  console.log('key 1======= >' + component.touch_down_enter)
                }else if(component.dialog_folder_create_visible){// 创建文件夹
                    let key = window.event.keyCode
                    if(key == 13){
                        // if(component.form.title.length > 0){
                            component.touch_down_enter = true
                            component.folder_creat_input_disabled = true
                            component.handleCreateFolder()
                            component.touch_down_enter = false
                        // }

                    }
                }
             }
        },

        mounted() {
            this.userinfo = {
                'nickname': '',
                'avatarInfo': ''
            }
            setTimeout(() => {
                this.from_folder_id = EUY.GetStorage('login_status').oid
                this.form_all_edit.parent_id = EUY.GetStorage('login_status').oid
                this.self_oid = EUY.GetStorage('login_status').oid
                EUY.SetStorage('team_info', '')
                // 定义平台参数
                let platform = this.$route.query.platform
                // 模块 HOMEPAGE
                // 模块初始化
                Protocol.onSocketInit(platform, HOMEPAGE_NAME, HOMEPAGE)
                // 模块与服务器建立链接
                Protocol.onSocketConnect(platform, HOMEPAGE_NAME)
                // 模块与服务器建立链接
                Protocol.onSocketRegister(platform, HOMEPAGE_NAME, HOMEPAGE)
                // 模块加载完成
                window[HOMEPAGE_NAME].domReady = () => {
                    let homepage_core_1_1 = {
                        packageId: 0,
                        senderId: HOMEPAGE,
                        senderName: HOMEPAGE_NAME,
                        receiverId: CORE,
                        receiverName: CORE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 1,
                        messageId: 1,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, homepage_core_1_1)
                    let homepage_core_1_3 = {
                        packageId: 0,
                        senderId: HOMEPAGE,
                        senderName: HOMEPAGE_NAME,
                        receiverId: CORE,
                        receiverName: CORE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 1,
                        messageId: 3,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    Protocol.sender(platform, homepage_core_1_3)
                }

                // 接收消息
                Protocol.receiver(platform, HOMEPAGE_NAME)
                window[HOMEPAGE_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {
                    if(sessionId == 1 && messageId == 2) {
                        let token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array.toString()
                        // 获取 token
                        this.token = token
                        this.handleGetIdentity()
                        this.handleGetTeamListDate()
                    }else if (sessionId == 1 && messageId == 4) {
                        let arr = Protocol.deserializeBinary('proto.com.proto.s.UserInfo', protoBytes).array
                        // 获取用户信息
                        this.userinfo.nickname = arr[3][4]
                        this.userinfo.avatarInfo = arr[5][2]
                        // 面包屑
                        this.breadcrumb = [
                            { name: this.userinfo.nickname, folder_id: '/' }
                        ]
                    }else if(sessionId == 10 && messageId == 1) {
                        let homepage_core_10_2 = {
                            packageId: 0,
                            senderId: HOMEPAGE,
                            senderName: HOMEPAGE_NAME,
                            receiverId: PLAYER,
                            receiverName: PLAYER_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 10,
                            messageId: 2,
                            protoBytesType: 'proto.com.proto.s.MString',
                            protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                                setValue: this.playerScriptId,
                            })
                        }
                        Protocol.sender(platform, homepage_core_10_2)
                    }else if(sessionId == 1 && messageId == 29) {
                        // 文字弹框的回调信息
                        // {"id":"907575710080410001001","value":"aaa1234"}
                        let textBoxBack = Protocol.deserializeBinary('proto.com.proto.s.MTextBoxBack', protoBytes).toObject();
                        // console.log('文字弹框的回调信息 ===> ' + JSON.stringify(textBoxBack))
                        if(this.home_template_save_id == textBoxBack.id){
                            this.handleTemplateTexBox(textBoxBack.id,textBoxBack.value);
                        }
                    }
                }
            }, 500)
        },

        methods: {
            // 检查指定资源类型的权限
            hasPermission(resourceType, requiredLevel = 1) {
                let permissions = this.currentTeamPermissions
                return permissions[resourceType] >= requiredLevel
            },
            
            // 检查是否有管理权限（创建文件夹、管理等）
            hasManagementPermission(resourceType) {
                return this.hasPermission(resourceType, 2)
            },
            
            // 检查是否有创建权限（创建资源）
            hasCreatePermission(resourceType) {
                return this.hasPermission(resourceType, 1)
            },
            
            handleOperation(item){
                this.homePageClick()
                console.log('handleOperation' + JSON.stringify(item))
                this.pay_money_status = false
                this.userInfoShow = true
                this.userInfoTitle = item
            },

            handleUserInfo(val){
                this.userInfoShow = val
            },

            changeHomePageUserIcon(val){
                this.userinfo.avatarInfo = val
            },

            homePageClick(){
                if(this.menuMoreList){
                    this.menuMoreList = false
                }
            },

            // 显示/关闭充值组件
            handleRecharge(val){
                this.userInfoShow = false
                this.pay_money_status = val
            },

            // 充值后的余额
            handUserCoupon(val){
                console.log('handUserCoupon ===> ' + val)
                this.user_export_money = val
            },

            handlePackage ()
            {
                this.upload = false
                this.no_permission = false;
                this.package_status = true
                this.team_management = false
                this.aiimage_status = false
                this.no_result = false
                this.type = 'purchased'
                for (let i = 0; i < this.menu_category.length; i++) {
                    this.menu_category[i].active = false
                }
                this.handleGetPackageData()

            },
            handleAiImage ()
            {
                this.upload = false
                this.no_permission = false;
                this.package_status = false
                this.team_management = false
                this.no_result = false
                this.type = 'aiimage'
                for (let i = 0; i < this.menu_category.length; i++) {
                    this.menu_category[i].active = false
                }
                this.aiimage_status = true
                this.showAiImageComponent = true

            },

            handlePackageDetail (item)
            {
                this.package_detail_status = true
                this.current_package_id = item.packageId
            },

            handleGoBack ()
            {
                this.package_detail_status = false
                this.current_package_id = null
                this.handleGetPackageData()
            },

            handleSearchClosePackage ()
            {
                this.search_key_package = ''
                this.handleGetPackageData()
            },

            handleSearchPackage ()
            {
                this.handleGetPackageData()
            },

            handleSizeChangePack (val)
            {
                this.page_size_pack = val
                this.handleGetPackageData()
            },

            handleCurrentChangePack (val)
            {
                this.current_page_pack = val
                this.handleGetPackageData()
            },

            handleGetPackageData ()
            {
                // alert(this.tab_team_id)
                if(this.tab_team_status == '0'){
                    this.handleGetPackageListData(this.current_page_pack, this.page_size_pack, this.search_key_package)
                }else{
                    this.handleGetTeamPackageListData (this.current_page, this.page_size, this.search_key, this.tab_team_id)
                }
            },

            handleC (id, name, type)
            {
                let platform = this.$route.query.platform
                // protobuf 打包
                let MTabData  = new proto.com.proto.s.MTabData()
                let MTabDataTabType = ''
                if(type == 'prop'){
                    MTabDataTabType = proto.com.proto.s.MTabData.TabType.PROP
                }
                if(type == 'material'){
                    MTabDataTabType = proto.com.proto.s.MTabData.TabType.ROLE
                }
                if(type == 'scene'){
                    MTabDataTabType = proto.com.proto.s.MTabData.TabType.SCENE
                }
                let proportion = '16:9'
                // protobuf 打包格式
                MTabData.setType(MTabDataTabType)
                MTabData.setId(id)
                MTabData.setTitle(name)
                MTabData.setScreentype(proportion)
                // protobuf 序列化
                let protoBytes = MTabData.serializeBinary()
                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes)
                let homepage_core_1_5 = {
                    packageId: 0,
                    senderId: HOMEPAGE,
                    senderName: HOMEPAGE_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 5,
                    protoBytesType: 'proto.com.proto.s.MTabData',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, homepage_core_1_5)
            },

            handleMenuMore ()
            {
                let left  =  $('.menu-more').offset().left - 45 + 'px'
                setTimeout(() => {
                    $('.homepage .menu-more-list').css({
                        left: left
                    })
                })
                this.menuMoreList = !this.menuMoreList
            },

            handleListMenuLast (index, data)
            {
                this.loading = true
                let newData = this.listMenuLast[index]
                let oldData = this.menu[1]
                this.menu[1] = newData
                this.listMenuLast[index] = oldData
                this.changeTab(1, this.menu)
                this.tab_team_status = 1
                EUY.SetStorage('team_info', this.menu[1])
                this.data = []
                this.total = 0
                this.folder_id = ''
                this.breadcrumb = [{ name: this.userinfo.nickname, folder_id: '/' }]
                this.tab_team_id = newData.oid
                // 修改 teamId
                console.log('newData.oid ====>' + newData.oid)
                this.$store.dispatch('updateTeamId', newData.oid)
                this.team_id = newData.oid
                this.from_folder_id = newData.oid
                this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                this.menuMoreList = !this.menuMoreList
            },

            handelCreatDom (id, name)
            {
                this.playerScriptId = id;
                this.playerScriptTitle = name;
            },

            //开通会员
            handleOpenVip ()
            {
                this.userInfoShow = false
                this.vip_dialog_visible = true
            },
            // 登出
            handleLoginOut ()
            {
                console.log('退出登录')
                let platform = this.$route.query.platform
                let homepage_core_1_25 = {
                    packageId: 0,
                    senderId: HOMEPAGE,
                    senderName: HOMEPAGE_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 25,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, homepage_core_1_25)
            },

            handleMenu(index, data)
            {
                console.warn('handleMenu ====>' + index, data)
                for(var i=0;i<this.$children.length;i++){
                    if(this.$children[i].$el.className == 'upload'){
                        clearTimeout(this.$children[i].get_status_time)
                    }
                }
                this.team_management = (index == '0' && this.type == 'team')?true:false
                this.current_page = 1
                if(this.tab_team_status != index){
                    this.package_status = false
                    this.package_detail_status = false
                    this.aiimage_status = false
                    this.showAiImageComponent = false
                    this.upload = false
                    if(index == 0){
                        EUY.SetStorage('team_info', '')
                    }else{
                        EUY.SetStorage('team_info', this.menu[index])
                    }
                    this.tab_team_status = index
                    this.data = []
                    this.total = 0
                    this.folder_id = ''
                    this.search_key = ''
                    this.sduiVisible = false
                    this.mediaUploadVisible = false
                    if(index == 0){
                        this.breadcrumb = [{ name: this.userinfo.nickname, folder_id: '/' }]
                        this.permission = 2
                        this.tab_team_id = ''
                        this.team_id = ''
                        this.$store.dispatch('updateTeamId', this.tab_team_id)
                        this.from_folder_id = EUY.GetStorage('login_status').oid
                        this.type = 'anim'
                        this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                    }else{
                        this.no_permission = false
                        // 侧边栏
                        this.menu_category = [
                            { name: '动画', type: 'anim', active: false, status: false },
                            { name: '模版', type: 'template',active: false, status: false },
                            { name: '场景', type: 'scene',active: false, status: false },
                            { name: '形象', type: 'material', active: false, status: false },
                            { name: '道具', type: 'prop', active: false, status: false },
                            { name: '动作', type: 'action', active: false, status: false },
                            { name: '组件', type: 'component',active: false, status: false },
                            { name: '背景音乐', type: 'bgm', active: false, status: false },
                        ]
                        this.breadcrumb = [{ name: data[index].nickname, folder_id: '/' }]
                        this.type = 'anim'
                        this.tab_team_id = data[index].oid
                        this.team_id = data[index].oid
                        this.$store.dispatch('updateTeamId', this.tab_team_id)
                        this.from_folder_id = data[index].oid
                        this.form_all_edit.parent_id = ""
                        this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                    }
                    for(let i = 0; i < data.length; i++) {
                        data[i].active = (i === index)
                    }
                    this.changeTab(index, data)
                    this.changeTab(0, this.menu_category)
                }
            },

            changeTab(index, data)
            {
                for (let i = 0; i < data.length; i++) {
                    if(data[i]) data[i].active = false
                }
                if(data[index]) data[index].active = true
                this.menu_category_select_index = index;
            },

            handleCreateAnim ()
            {
                let title = '未命名'
                let proportion = '16:9'
                this.handlePostCreateAnim(this.tab_team_id, this.folder_id, title, this.form_create_anim.proportion)
            },

            // 移动文件夹及文件
            handleUpdateFolder (type)
            {
                // console.log("type -----------:", type);
                // 隐藏修改弹窗
                this.dialog_edit_visible = false
                if (type == 'default') {
                    // console.log("parent_id-----------:", this.form_all_edit.parent_id);
                    if(this.touch_down_enter){
                        this.form_all_edit.parent_id = this.from_folder_id
                    }
                    this.handlePostFolderInfo (this.type, this.folder_file_data, this.from_folder_id, this.form_all_edit.parent_id, this.team_id, this.form_all_edit.title, this.form_all_edit.intro)
                }
                if (type == 'batch') {
                    // alert(1)
                    this.handlePostFolderMove (this.type, this.folder_file_data, this.from_folder_id, this.form_all_edit.parent_id, this.team_id)
                }
            },

            // 移动文件夹节点 ID
            handleNodeClick(data)
            {
                // ID
                this.form_all_edit.parent_id = data.id
            },

            // 删除文件夹及文件提示
            handleDialogDelete (type, title, id)
            {
                // 显示
                this.dialog_delete_visible = true
                // 类型
                this.folder_file_type = type
                // 标题
                this.folder_file_title = title
                // ID
                this.folder_file_id = id
            },

            handleDialogEdit (type, item)
            {
                //让文件所属文件夹还原
                this.clickFieldChangeStatus = false;
                // 显示
                this.dialog_edit_visible = true
                // 默认布局
                if (type == 'default') {
                    this.form_all_edit_batch_visible = false
                    this.form_all_edit_visible = true
                    this.folder_file_id = item.id
                    this.folder_file_data = item.id
                    this.handlePostFolderTree(this.type, this.folder_file_id, this.team_id)
                    this.form_all_edit.title = item.title
                    this.form_all_edit.intro = item.intro
                }
                // 管理布局
                if (type == 'batch') {
                    this.form_all_edit_batch_visible = true
                    this.form_all_edit_visible = false
                    this.handlePostFolderTree(this.type, this.folder_file_data, this.team_id)
                }
            },

            handleFolderDelete ()
            {
                this.folder_file_data.push(this.folder_file_id)
                this.dialog_delete_visible = false
                this.handlePostDeleteMyListDate (this.type, this.folder_file_data, this.team_id)
            },

            handleFolderGroupTop (id) {
                // alert(id)
            },

            handleButtonGroup1 ()
            {
                this.dialog_button_group_1_visible = false
                this.dialog_button_group_2_visible = true
                this.dialog_folder_group_selected_visible = true
                this.folder_file_data = []
            },

            handleButtonGroup2 ()
            {
                this.dialog_button_group_1_visible = true
                this.dialog_button_group_2_visible = false
                this.dialog_folder_group_selected_visible = false
                this.folder_file_data = []
            },

            handleFolderGroupShow ()
            {
                let el = event.currentTarget
                $(el).find('.folder-group').css('opacity', 1)
            },

            handleFolderGroupHide ()
            {
                let el = event.currentTarget
                $(el).find('.folder-group').css('opacity', 0)
            },

            handleTargetNav(index, folder_id)
            {
                let arr = []
                for (let i = 0; i < this.breadcrumb.length; i++) {
                    if (i <= index) {
                        arr.push(this.breadcrumb[i])
                    }
                }
                this.breadcrumb = arr
                if (folder_id == '/') {
                    this.folder_id = ''
                    if(this.tab_team_status == 0){
                        this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                    }else{
                        this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                    }
                    if(this.tab_team_status == 0){
                        this.from_folder_id = EUY.GetStorage('login_status').oid
                    }else{
                        this.from_folder_id = this.tab_team_id
                    }
                } else {
                    this.folder_id = folder_id
                    this.from_folder_id = folder_id
                    if(this.tab_team_status == 0){
                        this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                    }else{
                        this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                    }
                }
                // 保证跳转后左侧的选择不变
                this.changeTab(this.menu_category_select_index,this.menu_category)
            },

            handleTarget (type, name, id, proportion, item)
            {
                console.log('item ====> ' ,this.permission, type, name, id, proportion, JSON.stringify(item))
                if(this.dialog_button_group_1_visible) {
                    // 文件夹
                    if (type == 'folder') {
                        this.folder_id = id
                        this.from_folder_id = id
                        this.upload_folder_id = id
                        let page = 1
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, page, this.search_key, this.menu_category_select_index)
                        }else{
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, page, this.search_key)
                        }
                        this.breadcrumb.push({
                            name: name,
                            folder_id: id
                        })
                    }else { // 文件
                        // 背景音试听
                        if(this.type == 'bgm') {
                            this.dialog_bgm_listen_visible = true
                            this.$nextTick(() => {
                                this.handleSyncBgmDetail(item)
                            })
                        }
                        else{ // 其他素材
                            //权限技能播放
                            if(this.permission == 0){
                                // 动画播放
                                if(this.type == 'anim'){
                                    this.dialog_video_play_visible = true
                                    this.handelCreatDom(id, name)
                                }else{
                                    // alert('暂不支持该功能')
                                }
                            }else { // 其他权限制作动画
                                if(this.self_oid != item.creator_user_id && this.permission != 2 ){
                                    if(0 < this.permission) {
                                        this.dialog_video_play_visible = true
                                        return   this.handelCreatDom(id, name)
                                    }else {
                                        // alert('对不起没有该权限')
                                        return false
                                    }
                                }
                                let platform = this.$route.query.platform
                                if(this.type == 'anim' || this.type == 'scene' || this.type == 'material' || this.type == 'action' || this.type == 'template'){
                                    this.home_openAnim_item = item
                                    // 检查当前的id是否被其他人编辑,被编辑弹框提示,反之跳转
                                    this.handleAnimBeginEdit(item.id)
                                }else if(this.type == 'prop' || this.type == 'component'){
                                }else{
                                }
                            }
                        }
                    }
                }else{
                    // alert(1)
                    console.log('请选择！')
                }
                // 保证跳转后左侧的选择不变
                this.changeTab(this.menu_category_select_index,this.menu_category)
            },

            handleBgmPlay ()
            {
                let audio = document.getElementById('homepage_audio')
                this.play_status = false
                audio.play()
            },

            handleBgmPause ()
            {
                let audio = document.getElementById('homepage_audio')
                this.play_status = true
                audio.pause()
            },

            changeBgmTime (val)
            {
                let audio = document.getElementById('homepage_audio')
                audio.currentTime = val
                let minute = ''
                let second = ''
                minute = parseInt(parseInt(audio.currentTime)/60) >= 10 ? parseInt(parseInt(audio.currentTime)/60) : '0' + parseInt(parseInt(audio.currentTime)/60)
                second = parseInt(audio.currentTime)%60 >= 10 ? parseInt(audio.currentTime)%60 : '0' + parseInt(audio.currentTime)%60
                this.current  = minute + ':' + second
            },

            // 时间戳转换
            timestamp(date)
            {
                return moment(parseInt(date) * 1000).format('YYYY-MM-DD HH:mm:ss')
            },

            // 动画时长转化
            timestamp1(date)
            {
                if(date){
                    let minute = parseInt(parseInt(date)/60) >= 10 ? parseInt(parseInt(date)/60) : '0' + parseInt(parseInt(date)/60)
                    let second = parseInt(date)%60 >= 10 ? parseInt(date)%60 : '0' + parseInt(date)%60
                    return  minute + '：' + second
                }else{
                    return  '00' + '：' + '00'
                }
            },

            handleBtnCancel ()
            {
                this.dialog_file_create_visible = false
                this.dialog_folder_create_visible = false
                this.dialog_delete_visible = false
                this.dialog_edit_visible = false
            },

            handleCreateFolder ()
            {
                if(this.touch_down_enter){
                    if(this.form.title == undefined){
                        this.folder_creat_input_disabled = false
                        this.$message({
                        message: '请输入正确的文件夹名称',
                        type: 'error'
                        })
                        return
                    }
                }

                let title = this.form.title.replace(/(^\s*)|(\s*$)/g, "")
                if(title){
                    this.dialog_folder_create_visible = false
                    this.handlePostCreateFolder(this.type, this.form.title, this.folder_id, this.team_id)
                }else{
                    this.dialog_folder_create_visible = false
                    this.$message({
                        message: '请输入正确的文件夹名称',
                        type: 'error'
                    })
                }

            },

            handleSearch ()
            {
                let page = 1
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, page, this.search_key, this.menu_category_select_index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, page, this.search_key)
                }
            },

            handleSearchClose () {
                this.search_key = ''
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                }
            },

            handleSizeChange(val)
            {
                console.log(`每页 ${val} 条`);
            },

            handleCurrentChange(val)
            {
                console.log(`当前页: ${val}`);
            },

            handleMenuCategory(item, index, data)
            {
                this.menu_category_select_index = index
                this.package_status = false
                this.package_detail_status = false
                this.aiimage_status = false
                this.showAiImageComponent = false
                for(var i=0;i<this.$children.length;i++){
                    if(this.$children[i].$el.className == 'upload'){
                        clearTimeout(this.$children[i].get_status_time)
                    }
                }
                this.team_management = item.name == '团队管理'?true:false
                this.team_add_edit = false
                this.upload = false
                this.changeTab(index, data)
                this.category_txt = data[index].name
                this.type = item.type
                this.current_page = 1
                this.search_key = ''
                this.folder_id = ''
                this.no_result = false
                if(!this.home_uploading_back){
                    // 如果 home_uploading_back == true 需要保存当前文件夹路径
                    this.breadcrumb = [{ name: this.userinfo.nickname, folder_id: '/' }]
                }
                // this.breadcrumb = [{ name: this.userinfo.nickname, folder_id: '/' }]
                this.folder_file_data = []
                this.dialog_button_group_1_visible = true
                this.dialog_button_group_2_visible = false
                this.dialog_folder_group_selected_visible = false
                // console.log('home_uploading_back ==> ' + this.home_uploading_back)
                // 如果 home_uploading_back == true 则说明是从上传点击返回退出的
                if(this.home_uploading_back) {
                    this.home_uploading_back = false
                    return
                }
                
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                }
            },

            // current_page 改变时会触发--当前页
            handleCurrentChange(value)
            {
                this.current_page = value
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                }
            },

            // page-size 改变时会触发--当前个数
            handleSizeChange (value)
            {
                this.page_size = value
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                }
            },
            // ------------------------------------------------- [ API ] -------------------------------------------------

            // 同步背景音数据
            handleSyncBgmDetail (item)
            {
                this.bgm_title = item.title
                this.bgm_copyright = item.copyright
                this.audio_src = item.preview
                let audio = document.getElementById('homepage_audio')
                
                // 检查元素是否存在
                if (!audio) {
                    console.warn('Audio element not found')
                    return
                }
                
                audio.src = item.preview
                setTimeout(() => {
                    audio.play()
                    clearInterval(this.intervalid1)
                    this.max_time = parseInt(audio.duration)
                    let minute1 = parseInt(parseInt(audio.duration)/60) >= 10 ? parseInt(parseInt(audio.duration)/60) : '0' + parseInt(parseInt(audio.duration)/60)
                    let second1 = parseInt(audio.duration)%60 >= 10 ? parseInt(audio.duration)%60 : '0' + parseInt(audio.duration)%60
                    this.total_time  = minute1 + ':' + second1
                    let minute = ''
                    let second = ''
                    minute = parseInt(parseInt(audio.currentTime)/60) >= 10 ? parseInt(parseInt(audio.currentTime)/60) : '0' + parseInt(parseInt(audio.currentTime)/60)
                    second = parseInt(audio.currentTime)%60 >= 10 ? parseInt(audio.currentTime)%60 : '0' + parseInt(audio.currentTime)%60
                    this.current  = minute + ':' + second
                    this.value1 = parseInt(audio.currentTime)  // 初始化滑块位置
                    this.intervalid1 = setInterval (() => {
                        minute = parseInt(parseInt(audio.currentTime)/60) >= 10 ? parseInt(parseInt(audio.currentTime)/60) : '0' + parseInt(parseInt(audio.currentTime)/60)
                        second = parseInt(audio.currentTime)%60 >= 10 ? parseInt(audio.currentTime)%60 : '0' + parseInt(audio.currentTime)%60
                        this.current  = minute + ':' + second
                        this.value1 = parseInt(audio.currentTime)  // 更新滑块位置
                    },1000)
                }, 500)
            },

            // 创建副本
            handleFolderGroupCopy (id)
            {
                let platform = this.$route.query.platform
                const URL = '/api/storage/storage/resource/v1/copy'
                const headers = {
                    'Authorization': this.token,
                }
                const formData = new FormData();
                formData.append('id', id); 
                this.AJAX.post(URL, headers, formData).then((data)=>{
                    if(data.code == 10000) {
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                        }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                        }
                    }else {
                        throw new Error(response.message || '创建副本失败')
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 另存为模版
            handleTemplateSave(id){
                console.log('另存为模版')
                this.home_template_save_id = id
                let platform = this.$route.query.platform
                let homepage_core_1_28 = {
                    packageId: 0,
                    senderId: HOMEPAGE,
                    senderName: HOMEPAGE_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_HOMEPAGE_CORE_1_28,
                    protoBytesType: 'proto.com.proto.s.MTextBox',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MTextBox(), {
                        setId: id,
                        setTitle:'另存为模版',
                        setText:'模版名称',
                        setValue:'',
                        setButton:'保存',
                    })
                }
                    // string id = 1;
                    // string title = 2;
                    // string text = 3;
                    // string value = 4;
                    // string button = 6;
                    // 发送消息
                Protocol.sender(platform, homepage_core_1_28)
            },

            // 创建动画
            async handlePostCreateAnim (team_id, folder_id ,title, proportion)
            {
                let platform = this.$route.query.platform
                const URL = '/api/storage/storage/resource/v1/create/empty'
                const headers = {
                    'Authorization': this.token,
                }

                const formData = new FormData();
                formData.append('type', 'anim');
                formData.append('teamId', team_id); 
                formData.append('folderId', folder_id); 
                formData.append('title', title); 
                formData.append('proportion', proportion); 

                try {
                    const response = await this.AJAX.post(URL, headers, formData);
                    if(response.code == 10000) {
                        this.form_create_anim = {
                            id: '',
                            title: '',
                            proportion: '16:9'
                        }
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                        }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                        }
                        // protobuf 打包
                        let MTabData  = new proto.com.proto.s.MTabData()
                        let MTabDataTabType = proto.com.proto.s.MTabData.TabType.EDITOR
                        // protobuf 打包格式
                        MTabData.setType(MTabDataTabType)
                        MTabData.setTitle(response.datas.title)
                        MTabData.setId(response.datas.id)
                        MTabData.setScreentype(response.datas.proportion)
                        MTabData.setTeamid(EUY.GetStorage('team_info').oid)
                        MTabData.setTeamname(response.datas.creator)
                        // protobuf 序列化
                        let protoBytes = MTabData.serializeBinary()
                        // Uint8Array 转换 Array
                        let protoBytesArray = Array.from(protoBytes)
                        let homepage_core_1_5 = {
                            packageId: 0,
                            senderId: HOMEPAGE,
                            senderName: HOMEPAGE_NAME,
                            receiverId: CORE,
                            receiverName: CORE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 1,
                            messageId: MESSAGE_ID_HOMEPAGE_CORE_1_5,
                            protoBytesType: 'proto.com.proto.s.MTabData',
                            protoBytes: protoBytesArray
                        }
                        // 发送消息
                        Protocol.sender(platform, homepage_core_1_5)
                    }else {
                        throw new Error(response.message || '创建动画失败')
                    }
                }catch (error) {
                    this.$message({
                        message: error.message || '创建动画失败',
                        type: 'error'
                    })
                }
            },

            // 创建动作
            handlePostCreateAction ()
            {
                let platform = this.$route.query.platform

                const URL = process.env.HOST + '/api/storage/storage/resource/v1/create/empty'
                const headers = {
                    'Authorization': this.token,
                }

                const formData = new FormData();
                formData.append('type', 'action');
                formData.append('teamId', this.team_id); 
                formData.append('folderId', this.folder_id);  

                this.AJAX.post(URL, headers, formData).then((data)=>{
                    if(data.code === 10000){
                        // protobuf 打包
                        let MTabData  = new proto.com.proto.s.MTabData()
                        let MTabDataTabType = proto.com.proto.s.MTabData.TabType.ACTION
                        // protobuf 打包格式
                        MTabData.setType(MTabDataTabType)
                        MTabData.setId(data.datas.id)
                        MTabData.setTitle(data.datas.title)
                        MTabData.setTeamid(EUY.GetStorage('team_info').oid)
                        MTabData.setTeamname(data.datas.nickname)
                        // protobuf 序列化
                        let protoBytes = MTabData.serializeBinary()
                        // Uint8Array 转换 Array
                        let protoBytesArray = Array.from(protoBytes)
                        let homepage_core_1_5 = {
                            packageId: 0,
                            senderId: HOMEPAGE,
                            senderName: HOMEPAGE_NAME,
                            receiverId: CORE,
                            receiverName: CORE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 1,
                            messageId: 5,
                            protoBytesType: 'proto.com.proto.s.MTabData',
                            protoBytes: protoBytesArray
                        }
                        // 发送消息
                        Protocol.sender(platform, homepage_core_1_5)
                    }else{
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 获取文件夹及文件标题简介
            handleGetFolderInfo (type, folder_id, team_id)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/pro/api/ResourceFolder/detail'
                let headers = {
                    'token': this.token
                }
                let params = {
                    'type': type,
                    'id': folder_id,
                    'team_id': team_id
                }
                this.AJAX.get(URL, headers, params, platform).then((data)=>{
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            //修改文件信息
            handlePostFolderInfo (type, id, from_folder_id, to_folder_id, team_id, title, intro)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/resource/update'
                let params = 'type=' + type + '&id=' + id.toString() + '&toFolderId=' + to_folder_id + '&teamId=' + team_id + '&title=' + title + '&intro=' + intro
                const formData = new FormData();
                formData.append('type', type);
                formData.append('id', id.toString());
                formData.append('toFolderId', to_folder_id);
                formData.append('teamId', team_id);
                formData.append('title', title);
                formData.append('intro', intro);
                let headers = {
                    'Authorization': this.token,
                }
                // console.log('params ==> ' + params)
                this.AJAX.post(URL, headers, formData, platform).then((data)=>{
                    if(data.code==10000){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        })
                        this.folder_name_input_disabled = false
                        this.form_all_edit_visible = false
                        this.form_all_edit.parent_id = ''
                        this.folder_file_data = []
                        let tabs = EUY.GetStorage('tabs');
                        if(null != tabs && Array.isArray(tabs)) {
                            for(let i = 0;i < tabs.length; i++) {
                                if(tabs[i].id == id.toString()) {
                                    tabs[i].title = title;
                                    this.$parent.tabs = tabs;
                                    EUY.SetStorage('tabs',tabs);
                                    break;
                                }
                            }
                        }
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                        }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.form_all_edit_visible = false
                    this.folder_name_input_disabled = false
                    this.$message({
                        message: err.message,
                        type: 'error'
                    })
                })
            },

            clickFieldChange(){
                this.clickFieldChangeStatus = true;
            },

            // 文件的移动
            handlePostFolderMove (type, id, from_folder_id, to_folder_id, team_id)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/resource/batch-move'
                let params = new URLSearchParams()
                params.append('type', type)
                params.append('ids', id)  // 单个ID也作为数组处理
                params.append('toFolderId', to_folder_id)
                params.append('teamId', team_id)
                
                let headers = {
                    'Authorization': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
                this.AJAX.post(URL, headers, params, platform).then((data)=>{
                    if(data.code == 10000) {
                        this.$message({
                            message: '移动成功',
                            type: 'success'
                        })
                        this.form_all_edit.parent_id = ''
                        this.folder_file_data = []
                        this.dialog_button_group_1_visible = true
                        this.dialog_button_group_2_visible = false
                        this.dialog_folder_group_selected_visible = false
                        this.folder_file_data = []
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                        }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 获取树结构
            handlePostFolderTree (type, id, team_id)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/folder/tree'
                let params = {
                    type: type,
                    teamId: team_id
                }
                if (id) {
                    params.id = id
                }
                let headers = {
                    'Authorization': this.token,
                    'Content-Type': 'application/json'
                }
                this.AJAX.get(URL, headers, params, platform).then((data)=>{
                    if(data.code == 10000) {
                        this.form_all_edit.directory = data.datas;
                        if(''== this.folder_id && 'undefined' != typeof this.form_all_edit.directory[0]) {
                            this.folder_id =  this.form_all_edit.directory[0].id;
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.message,
                        type: 'error'
                    })
                })
            },

            // 删除
            handlePostDeleteMyListDate (type, id, team_id)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/resource/delete'
                let params = 'type=' + type + '&id=' + id + '&teamId=' + team_id
                let headers = {
                    'Authorization': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, platform).then((data)=>{
                    if(data.code == 10000) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.dialog_button_group_1_visible = true
                        this.dialog_button_group_2_visible = false
                        this.dialog_folder_group_selected_visible = false
                        this.folder_file_data = []
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                            }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 创建文件夹
            handlePostCreateFolder (type, title, parent_id, team_id)
            {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/folder/create'

                const formData = new FormData();
                formData.append('type', type);
                formData.append('title', title); 
                formData.append('toFolderId', parent_id); 
                formData.append('teamId', team_id); 

                let headers = {
                    'Authorization': this.token
                }
                this.AJAX.post(URL, headers, formData, platform).then((data)=>{
                    if(data.code == 10000) {
                        this.folder_creat_input_disabled = false
                        this.form.title = ''
                        // 我的
                        if(this.tab_team_status == 0){
                            this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, this.menu_category_select_index)
                        }else{ // 团队
                            this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.message,
                        type: 'error'
                    })
                })
            },

            // 素材列表---我的
            handleGetMyListDate (type, folder_id, page_size, current_page, search_key, index)
            {
                this.data = []
                // 侧边栏
                this.menu_category = [
                    { name: '动画', type: 'anim', active: false, status: true },
                    { name: '模版', type: 'template',active: false, status: true },
                    { name: '场景', type: 'scene',active: false, status: true },
                    { name: '形象', type: 'material', active: false, status: true },
                    { name: '道具', type: 'prop', active: false, status: true },
                    { name: '动作', type: 'action', active: false, status: true },
                    { name: '组件', type: 'component',active: false, status: true },
                    { name: '背景音乐', type: 'bgm', active: false, status: true },
                    { name: '团队管理', type: 'team', active: false, status: true },
                ]
                // this.identity = {
                //         name: '专业版',
                //         limittime: '',
                //         permission:{
                //             "anim":2,
                //             "component":2,
                //             "template":2,
                //             "scene":2,
                //             "material":2,
                //             "prop":2,
                //             "action":2,
                //             "bgm":2,
                //             "team":2
                //         },
                //     }
                if(this.identity.name == '个人版'){
                    if(index){
                        this.changeTab(index, this.menu_category)
                    }
                    this.no_permission = true
                    return false
                }else{

                    this.no_permission = true

                    for(var i =0;i<this.menu_category.length;i++){
                        if(this.menu_category[i].type == 'anim'){
                            this.menu_category[i].status = this.identity.permission.anim == '2' ? false:true
                        }else if(this.menu_category[i].type == 'template'){
                            this.menu_category[i].status = this.identity.permission.template == '2' ? false:true
                        }else if(this.menu_category[i].type == 'scene'){
                            this.menu_category[i].status = this.identity.permission.scene == '2' ? false:true
                        }else if(this.menu_category[i].type == 'material'){
                            this.menu_category[i].status = this.identity.permission.material == '2' ? false:true
                        }else if(this.menu_category[i].type == 'prop'){
                            this.menu_category[i].status = this.identity.permission.prop == '2' ? false:true
                        }else if(this.menu_category[i].type == 'action'){
                            this.menu_category[i].status = this.identity.permission.action == '2' ? false:true
                        }else if(this.menu_category[i].type == 'component'){
                            this.menu_category[i].status = this.identity.permission.component == '2' ? false:true
                        }else if(this.menu_category[i].type == 'bgm'){
                            this.menu_category[i].status = this.identity.permission.bgm == '2' ? false:true
                        }else if(this.menu_category[i].type == 'team'){
                            this.menu_category[i].status = this.identity.permission.team == '2' ? false:true
                        }
                    }

                    if(index!=undefined){
                        this.no_permission = this.menu_category[index].status;
                        this.changeTab(index, this.menu_category)
                    }

                    if(this.no_permission) return false;
                }

                let platform = this.$route.query.platform
                this.loading = false
                let isTeamManage = type == 'team' && this.tab_team_status == '0'
                let headers = {
                    'Authorization': this.token
                }

                if (!isTeamManage){
                    let URL = process.env.HOST + '/api/storage/storage/resource/v1/list'
                    let  params = {
                        'type': type,
                        'folderId': folder_id,
                        'pageSize': page_size,
                        'page': current_page,
                        'keyword': search_key
                    }
                    this.AJAX.get(URL, headers, params, platform).then((data)=>{
                        if(data.code == 10000) {
                            this.data = data.datas.rows
                            this.total = data.datas.total
                            // 判断结果是否为空
                            if(data.datas.rows.length == 0){
                                this.no_result = true
                            }else{
                                this.no_result = false
                            }
                        }else {
                            this.$message({
                                message: data.message,
                                type: 'error'
                            })
                        }
                        // 加载状态隐藏
                        this.loading = false
                    }).catch((err)=>{
                        console.log('团队管理出错 11111=> ' + JSON.stringify(err) + JSON.stringify(params))
                        this.loading = false
                        this.$message({
                            message: err.message,
                            type: 'error'
                        })
                    })
                }else{
                    this.handleGetTeamMembers()
                }
            },

            // 素材列表--团队
            handleGetTeamMatterListDate (type, team_id, folder_id, page_size, current_page, search_key)
            {
                let platform = this.$route.query.platform
                this.data = []
                this.loading = false
                let URL = process.env.HOST + '/api/storage/storage/resource/v1/list'
                let headers = {
                    'Authorization': this.token
                }
                let params = {
                    'type': type,
                    'folderId': folder_id,
                    'pageSize': page_size,
                    'page': current_page,
                    'keyword': search_key,
                    'teamId': team_id
                }
                this.AJAX.get(URL, headers, params, platform).then((data)=>{
                    if(data.code == 10000) {
                        // 列表赋值
                        this.data = data.datas.rows
                        this.total = data.datas.total
                        // 判断结果是否为空
                        if(this.data.length == 0){
                            this.no_result = true
                        }else{
                            this.no_result = false
                        }
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                    
                    // 加载状态隐藏
                    this.loading = false
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 团队列表
            handleGetTeamListDate ()
            {
                let URL = process.env.HOST + '/api/storage/team/user/teams'
                let platform = this.$route.query.platform
                let headers = {
                    'Authorization': this.token
                }
                this.menu = [
                            { nickname: '我的', active: true, permission: 2, permissions: { material: 2, prop: 2, action: 2, bgm: 2, anim: 2, scene: 2, component: 2, soundeffect: 2 }}
                        ]
                let params = {}
                this.AJAX.get(URL, headers, params, platform).then((data)=>{
                    this.menuLength = document.body.clientWidth - 400
                    this.menuNum = parseInt(this.menuLength/180)
                    if(data.code === 10000 && data.datas && data.datas.rows && data.datas.rows.length > 0){
                        for(var k=0;k<data.datas.rows.length;k++){
                            data.datas.rows[k].active = false
                            // Keep backward compatibility by setting permission based on permissions map
                            if (data.datas.rows[k].permissions) {
                                // If user has any management permission (value 1), set permission to 2
                                // Otherwise set to 1 if they have any permission, or 0 if no permissions
                                let hasManagementPerm = Object.values(data.datas.rows[k].permissions).some(perm => perm === 1)
                                let hasAnyPerm = Object.values(data.datas.rows[k].permissions).some(perm => perm > 0)
                                data.datas.rows[k].permission = hasManagementPerm ? 2 : (hasAnyPerm ? 1 : 0)
                            } else {
                                data.datas.rows[k].permission = 0
                                data.datas.rows[k].permissions = {}
                            }
                        }
                        this.listMenuAll = data.datas.rows
                        let nums = 0
                        if(data.datas.rows.length >= this.menuNum){
                            nums = this.menuNum
                            this.menuMore = true
                            for(var j=nums;j<data.datas.rows.length;j++){
                                if(data.datas.rows[j].oid != EUY.GetStorage('login_status').oid){
                                    this.listMenuLast.push(data.datas.rows[j])
                                }
                            }
                        }else{
                            nums = data.datas.rows.length
                            this.menuMore = false
                        }
                        for(var i=0;i<nums;i++){
                            if(data.datas.rows[i].oid != EUY.GetStorage('login_status').oid){
                                this.listMenuShow.push(data.datas.rows[i])
                            }
                        }
                        this.menu = this.menu.concat(this.listMenuShow)

                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 获取团队成员列表
            handleGetTeamMembers() {
                let URL = process.env.HOST + '/api/storage/team/members'
                let platform = this.$route.query.platform
                let headers = {
                    'Authorization': this.token
                }
                let params = {
                }
                
                this.AJAX.get(URL, headers, params, platform).then((data) => {
                    if (data.code === 10000) {
                        this.team_management_result = data.datas.members
                        this.team_manager_numbers = data.datas.maxMember
                        // 判断结果是否为空
                        if(data.datas.members.length == 0){
                            this.no_result = true
                        }else{
                            this.no_result = false
                        }
                        // 加载状态隐藏
                        this.loading = false
                    } else {
                        this.$message({
                            message: data.message || '获取团队成员列表失败',
                            type: 'error'
                        })
                    }
                }).catch((err) => {
                    this.$message({
                        message: err.message || '获取团队成员列表失败',
                        type: 'error'
                    })
                })
            },

            // 获取用户版本权限
            handleGetIdentity()
            {
                let URL = process.env.HOST + '/pro/api/user/identity'
                this.$http({
                    method: 'GET',
                    url: URL,
                    headers: {
                        token: this.token
                    },
                    emulateJSON: true
                }).then((response) => {
                    let res = response.body
                    this.identity = {
                        name: res.result.name,
                        viplevel: res.result.viplevel,
                        limittime: res.result.limittime,
                        permission:res.result.permission,
                    }
                    this.user_export_money = res.result.export_coupon
                    // console.log('获取用户版本权限 ==> ' + JSON.stringify(res))
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, 0)
                })
            },

            // 获取素材包列表---我的
            handleGetPackageListData (current_page, page_size, search_key)
            {
                this.package_list_data = []
                this.loading = false
                let URL = process.env.HOST + '/api/storage/market/packages/purchased'
                let headers = {
                    'Authorization': this.token
                }
                let params = {
                    'page': current_page,
                    'pageSize': page_size,
                    'keyword': search_key
                }
                this.AJAX.get(URL, headers, params).then((data)=>{
                    // 列表赋值
                    this.package_list_data = data.datas.rows
                    this.total_pack = data.datas.total
                    if(0 >= data.datas.total){
                        this.no_result = true;
                        this.category_txt = '您';
                    }else{
                        this.no_result = false;
                    }
                    this.loading = false
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 获取素材包列表---团队
            handleGetTeamPackageListData (current_page, page_size, search_key, team_id)
            {
                this.package_list_data = []
                this.loading = false
                let URL = process.env.HOST + '/api/storage/market/packages/purchased'
                let headers = {
                    'Authorization': this.token
                }

                let params = {
                    'page': current_page,
                    'pageSize': page_size,
                    'keyword': search_key,
                    'teamId': team_id
                }

                this.AJAX.get(URL, headers, params).then((data)=>{
                    // 列表赋值
                    this.package_list_data = data.datas.rows
                    this.total_pack = data.datas.total
                    if(0 >= data.datas.total) {
                        this.no_result = true;
                        this.category_txt = '';
                    }
                    this.loading = false
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },


            // 添加团队成员
            addTeamMembers (){
                console.log('添加团队成员')
                this.team_add_edit = true
                this.team_add_edit_title = '添加'
                // 保存按钮的状态
                this.team_saveBtn_status = false
                // // 清空数据
                // this.ruleForm.name = ''
                // this.team_member_name = ''
                // for (var i = 0;i < this.team_class_member.length;i++){
                //     this.team_class_member[i].checked = false
                // }
                // this.team_management_check_group = []
            },

            // 编辑和添加团队成员的返回按钮
            hanadleBack (){
                this.team_add_edit = false

                // 清空数据
                this.ruleForm.name = ''
                this.team_member_name = ''
                for (var i = 0;i < this.team_class_member.length;i++){
                    this.team_class_member[i].checked = false
                    this.team_class_member[i].select = ''
                    this.team_class_member[i].permission = ''
                }
                this.team_management_check_group = []
                this.team_select_0 = ''
                this.team_select_1 = ''
                this.team_select_2 = ''
                this.team_select_3 = ''
                this.team_select_4 = ''
                this.team_select_5 = ''
                this.team_select_6 = ''
                this.team_select_7 = ''

            },
            // -------------------------------------------------- [ 团队管理多选框相关 ] --------------------------------------------------
            // 处理动画多选框的事件
            handleAnimCheckbox(value){
                this.team_class_member[0].checked = value
                 console.log('handleAnimCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理形象多选框的事件
            handleMaterialCheckbox(value){
                this.team_class_member[1].checked = value
                //  console.log('handleMaterialCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理动作多选框的事件
            handleActionCheckbox(value){
                this.team_class_member[2].checked = value
                //  console.log('handleActionCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理道具多选框的事件
            handlePropCheckbox(value){
                this.team_class_member[3].checked = value
                //  console.log('handlePropCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理场景多选框的事件
            handleSceneCheckbox(value){
                this.team_class_member[4].checked = value
                //  console.log('handleSceneCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理背景音多选框的事件
            handleBgmCheckbox(value){
                this.team_class_member[5].checked = value
                //  console.log('handleBgmCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理模版多选框的事件
            handleTemplateCheckbox(value){
                this.team_class_member[6].checked = value
                //  console.log('handleTemplateCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },

            // 处理组件多选框的事件
            handleComponentCheckbox(value){
                this.team_class_member[7].checked = value
                //  console.log('handleComponentCheckbox ==> ' + value)
                 // 判断保存按钮的状态
                this.handleTeamSaveBtnStatus()
            },
            // -------------------------------------------------- [ 团队管理选择框相关 ] --------------------------------------------------
            // 动画选择框
            hanadleAnimSelect(value){
                this.team_class_member[0].select = value
            },

            // 形象选择框
            hanadleMaterialSelect(value){
                this.team_class_member[1].select = value
            },

            // 动作选择框
            hanadleActionSelect(value){
                this.team_class_member[2].select = value
            },

            // 道具选择框
            hanadlePropSelect(value){
                this.team_class_member[3].select = value
            },

            // 场景选择框
            hanadleSceneSelect(value){
                this.team_class_member[4].select = value
            },

            // 背景音选择框
            hanadleBgmSelect(value){
                this.team_class_member[5].select = value
            },

            // 模版选择框
            hanadleTemplateSelect(value){
                this.team_class_member[6].select = value
            },

            // 组件选择框
            hanadleComponentSelect(value){
                this.team_class_member[7].select = value
            },

            // 成员账号输入框
            teamTitleInput(value){
                // console.log('aaaaaaaa ==> ' + JSON.stringify(value) + this.ruleForm.name)
                if(this.ruleForm.name.length == 0) {
                    this.team_member_name = ''
                    // 判断保存按钮的状态
                    this.handleTeamSaveBtnStatus()
                    return
                }
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/pro/api/user/getUserInfoByLoginName'
                let headers = {
                    'token': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                let params = {'login_name':this.ruleForm.name}
                // 校验账号
                this.AJAX.get(URL, headers, params, platform).then((data)=>{
                        if(data.code == 0) {
                            this.team_member_exist = true
                            let temp = {}
                            for(var item in data.result){
                                temp = data.result[item]
                            }
                            this.team_member_id = temp.oid
                            this.team_member_name = temp.nickname
                            // 判断保存按钮的状态
                            this.handleTeamSaveBtnStatus()
                        }else{
                            this.team_member_exist = false
                        }

                    }).catch((err)=>{
                        console.log('校验错误 ==> ' + JSON.stringify(err))
                        // 判断保存按钮的状态
                        this.handleTeamSaveBtnStatus()
                        this.team_member_exist = false
                    })

            },

            // 提交保存方法
            team_management_save(){
                let platform = this.$route.query.platform
                // 是否是添加成员
                let isTeamMemberAdd = this.team_add_edit_title == '添加'
                
                let URL = process.env.HOST + '/api/storage/team/member'
                if (!isTeamMemberAdd) {
                    URL += '/permission'
                }
                
                // 收集选中的资源类型和权限
                let resourceTypes = []
                let permissions = []
                for(var i = 0; i < this.team_class_member.length; i++){
                    if(this.team_class_member[i].checked){
                        resourceTypes.push(this.team_class_member[i].type)
                        // 勾选了多选框，但没有勾选下拉框,使用默认值
                        if(this.team_class_member[i].select == ''){
                            permissions.push(this.team_class_member[i].default)
                        }else{
                            permissions.push(this.team_class_member[i].select)
                        }
                    }
                }
                
                // 构建参数对象
                let params = {
                    userId: isTeamMemberAdd ? this.team_member_id : this.team_member_info.userId,
                    resourceType: resourceTypes,
                    permission: permissions
                }

                let formData = new FormData()
                formData.append('userId', isTeamMemberAdd ? this.team_member_id : this.team_member_info.userId)
                formData.append('resourceType', resourceTypes)
                formData.append('permission', permissions)
                
                let headers = {
                    'Authorization': this.token
                }
                
                console.log('保存参数 => ', params)
                
                // 根据操作类型选择请求方法
                let request = this.AJAX.post(URL, headers, formData, platform)
                
                request.then((data)=>{
                        if(data.code === 10000){
                            console.log('添加成功 => ' + JSON.stringify(data))
                            // 返回上一层
                            this.hanadleBack ()
                            // 重新刷新数据后会使侧边栏选项改变,需要重新设置一下
                            this.upload = false
                            for(var i=0;i < this.menu_category.length;i++){
                                if(this.menu_category[i].name =='团队管理'){
                                    // 刷新数据
                                this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, i)
                                break;
                                }
                            }
                        }else{
                            this.$message({
                                message: data.message,
                                type: 'error'
                            })
                        }

                    }).catch((err)=>{
                        console.log('添加出错 => ' + JSON.stringify(err))
                        this.$message({
                            message: err.msg||err.message,
                            type: 'error'
                        })
                    })
            },

            // 团队成员编辑的方法
            handleTeamMemberEdit(index,data){
                this.team_add_edit = true
                this.team_add_edit_title = '编辑'
                // 保存按钮的状态
                this.team_saveBtn_status = true
                // 显示账号和昵称
                this.team_member_info.userId = data.userId
                this.team_member_info.username = data.username
                this.team_member_info.nickname = data.nickname
                // 显示该成员拥有的权限
                for (var i = 0;i < data['permissions'].length;i ++){
                    let key =  data['permissions'][i].type
                    let permission = data['permissions'][i].permission
                    this.team_management_check_group.push(this.classMap[key])
                    // 将对应的勾选框的下拉框显示出来
                    for (var j = 0;j < this.team_class_member.length;j ++){
                        if (key == this.team_class_member[j]['type']){
                            this.team_class_member[j].checked = true
                            this.team_class_member[j].permission = permission
                            this.team_class_member[j].select = permission
                            break
                        }
                    }
                }
            },
            // 删除
            memberDelete (index){
                this.centerDialogVisible = true
                this.deleteIndex = index
            },
            // 团队成员删除的方法
            handleTeamMemberDelete(){
                this.centerDialogVisible = false
                let deleteData = this.team_management_result[this.deleteIndex]
                let platform = this.$route.query.platform
                let URL =  process.env.HOST + '/api/storage/team/member/delete'
                let params = 'userId=' + deleteData.userId
                let headers = {
                    'Authorization': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, platform).then((data)=>{
                    if(data.code == 10000) {
                        this.centerDialogVisible = false
                        this.team_management_result.splice(this.deleteIndex,1)
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            // 判断保存按钮能否点击
            handleTeamSaveBtnStatus(){
                // 成员账号／成员昵称存在，点击至少一个成员角色
                let count = 0
                for(var i =0;i<this.team_class_member.length;i++){
                    if(this.team_class_member[i].checked){
                        count += 1
                    }
                }
                if(this.team_add_edit_title == '添加'){
                    let saveStatus = this.ruleForm.name.length > 0 && this.team_member_name.length > 0 && count > 0
                    this.team_saveBtn_status = saveStatus ? true:false
                }
                else if (this.team_add_edit_title == '编辑'){
                    this.team_saveBtn_status = count > 0 ? true:false
                }

            },

            // 上传场景／形象／道具／背景音
            handleUploading(type){
                if(type == 'scene' || type == 'prop'){
                    this.sduiType = type;
                    this.sduiTeamId = this.tab_team_id;
                    this.sduiFolderId = this.folder_id;
                    this.mediaUploadVisible = true;
                    this.upload = false;
                }else {
                    this.home_uploading = '';
                    this.upload = true;
                    this.mediaUploadVisible = false;
                }
                
            },
            handleAiProcessing(type) {
                this.sduiType = type;
                this.sduiTeamId = this.tab_team_id;
                this.sduiFolderId = this.folder_id;
                this.sduiWorkflowId = '';
                this.sduiVisible = true;
            },
            
            // 处理从AiImage组件跳转到SDUi的事件
            handleNavigateToSdui(workflowId) {
                // 如果SDUi已经显示，则只更新workflowId
                if (this.sduiVisible) {
                    this.sduiWorkflowId = workflowId;
                } else {
                    // 如果SDUi未显示，则设置所有参数并显示
                    this.sduiType = '';
                    this.sduiTeamId = this.tab_team_id;
                    this.sduiFolderId = this.folder_id;
                    this.sduiWorkflowId = workflowId;
                    this.sduiVisible = true;
                }
            },
            
            // 刷新资源列表
            refreshResourceList() {
                // 刷新当前资源列表
                if(this.tab_team_status == 0){
                    this.handleGetMyListDate(this.type, this.folder_id, this.page_size, this.current_page, this.search_key, index)
                }else{
                    this.handleGetTeamMatterListDate(this.type, this.tab_team_id, this.folder_id, this.page_size, this.current_page, this.search_key)
                }
            },
            handleCommand(command) {
                const { type, action } = command
                console.log(command, type, action)
                switch(action) {
                    case "upload":
                        this.handleUploading(type);
                        break;
                    case "ai":
                        this.handleAiProcessing(type);
                        break;
                    default:
                        console.log("参数错误!", action);
                }
            },
            // 处理重新上传形象
            handleAfreshUploading(item){
                this.home_uploading = item
                this.upload = true
                console.log('ddd === '+item.type + item.title + ' <==> ' + JSON.stringify(item))
            },

            // 检查动画是否被编辑
            handleAnimBeginEdit(id){
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/api/storage/storage/resource/begin-edit'
                let params = 'id=' + id
                let headers = {
                    'Authorization': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, platform).then((data)=>{
                    if(data.code === 10000){
                        let id = this.home_openAnim_item.id
                        let name = this.home_openAnim_item.title
                        let proportion = this.home_openAnim_item.proportion
                        let MTabDataTabType;
                        this.dialog_edit_anim = false
                        if(this.type == 'anim' || this.type == 'template'){
                            MTabDataTabType = proto.com.proto.s.MTabData.TabType.EDITOR
                        }
                        else if(this.type == 'scene'){
                            MTabDataTabType = proto.com.proto.s.MTabData.TabType.SCENE
                        }
                        else if(this.type == 'material'){
                            MTabDataTabType = proto.com.proto.s.MTabData.TabType.ROLE
                        }
                        else if(this.type == 'action'){
                            MTabDataTabType = proto.com.proto.s.MTabData.TabType.ACTION
                        }
                        console.log(`current ${this.type} do not edit ---------> ` + id)
                        this.handleOpenWindow(id, name, proportion, MTabDataTabType)
                    }else {
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch((err)=>{
                    if(err.code != undefined){
                        console.log(`current ${this.type} is editing ---------> ` + JSON.stringify(err) + JSON.stringify(params))
                        this.dialog_edit_anim = true
                        this.dialog_edit_anim_msg = err.msg
                    }
                })
            },

            // 查看正在被编辑的动画
            checkEditingAnim(){
                this.dialog_edit_anim = false
                this.dialog_video_play_visible = true
                this.handelCreatDom(this.home_openAnim_item.id, this.home_openAnim_item.name)
            },

            // 首页打开窗口的方法(动画／场景／形象／动作)
            handleOpenWindow(id, name, proportion, dataTabType){
                let platform = this.$route.query.platform
                let MTabData  = new proto.com.proto.s.MTabData()
                let MTabDataTabType = dataTabType
                // protobuf 打包格式
                MTabData.setType(MTabDataTabType)
                MTabData.setTitle(name)
                MTabData.setId(id)
                MTabData.setScreentype(proportion)
                MTabData.setTeamid(EUY.GetStorage('team_info').oid)
                MTabData.setTeamname(EUY.GetStorage('team_info').nickname)
                // protobuf 序列化
                let protoBytes = MTabData.serializeBinary()
                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes)
                let homepage_core_1_5 = {
                    packageId: 0,
                    senderId: HOMEPAGE,
                    senderName: HOMEPAGE_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 5,
                    protoBytesType: 'proto.com.proto.s.MTabData',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, homepage_core_1_5)
            },

            // 首页动画保存为模版
            handleTemplateTexBox(id, title){
                //
                let platform = this.$route.query.platform

                const URL = '/api/storage/storage/resource/v1/anim/copyToTemplate'
                const headers = {
                    'Authorization': this.token,
                }
                const formData = new FormData();
                formData.append('id', id); 
                formData.append('title', title);


                this.AJAX.post(URL, headers, formData).then((data)=>{
                    if(data.code == 10000){
                        this.home_template_save_id = ''
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                    }
                }).catch((err)=>{
                    this.$message({
                        message: err.message,
                        type: 'error'
                    })
                })
            },
            handleQrcode(qrcode) {
                // 处理微信支付二维码
                this.$alert(`<img src="${qrcode}" style="width:200px;height:200px;">`, '请使用微信扫码支付', {
                  dangerouslyUseHTMLString: true,
                  showClose: true,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  showConfirmButton: false,
                  callback: () => {
                    // 关闭二维码后的回调
                  }
                })
            },
        },
        watch: {
            'dialog_bgm_listen_visible': function()
            {
                if(!this.dialog_bgm_listen_visible){
                    let audio = document.getElementById('homepage_audio')
                    audio.pause()
                    this.current = 0
                    this.total_time = ''
                    this.value1 = 0
                }
            },
            'upload':function(curVal,oldVal){
                console.warn('curl=='+curVal)
                console.warn('old=='+oldVal)
                if(curVal == false && oldVal == true)
                {
                    $('.menu .active').click();
                }
            }
        },
    }
</script>

<style>
.el-collapse .el-collapse-item__header{
  background:#303030;
  color:#fff;
}
.el-collapse .el-collapse-item__wrap{
  background:#303030;
  color:#fff;
}
.el-table__body tr:hover>td{
    background-color: initial !important;
    cursor: pointer;
}
.el-form .el-form-item__label{
    color:#e2e2e2;
}
.el-checkbox .el-checkbox__label{
    color:#e2e2e2;
}
.el-dialog .el-form-item__label{
    color:#2f2f2f;
}
::-webkit-scrollbar {
     width: 5px;
}
::-webkit-scrollbar-track {
    background: #bee1eb;
}
::-webkit-scrollbar-track-piece{
    background: #2a2a2a;
}
::-webkit-scrollbar-thumb {
     background: #b3b3b3;
}

/* ::-webkit-scrollbar-thumb:hover {
    background-color: #9c3
}

::-webkit-scrollbar-thumb:active {
     background: blue;
}


/* .el-dialog .el-dialog__header{
    background:green;
    color:red;
}
.el-dialog .el-dialog__footer{
    background:blue;
    color:red;
}
.el-dialog .el-dialog__body{
    background:yellow;
    color:red;
} */
</style>

<style scoped>


  .cl-effect-4 li {
    position: relative;
  }

  .cl-effect-4 li::after {

  }

  .cl-effect-4 li:hover::after,
  .cl-effect-4 li:focus::after {
    height: 3px;
    opacity: 1;
    transform: translateY(0px);
  }
  .cl-effect-5 div {
    overflow: hidden;
  }

  .cl-effect-5 div span {
    position: relative;
    display: block;
    transition: transform .5s;
  }

  .cl-effect-5 div span::before {
    position: absolute;
    top: 100%;
    content: attr(data-hover);
    transform: translate3d(0,0,0);
  }

  .cl-effect-5 div:hover span,
  .cl-effect-5 div:focus span {
    /* transform: translateY(-100%); */
  }

  .cl-effect-8 .pic::before,
  .cl-effect-8 .pic::after  {
    position: absolute;
    top: -1px;
    left: -1px;
    content: '';
    transition: transform .5s, opacity .5s;
  }

  .cl-effect-8 .pic::after  {
    opacity: 0;
    transform: translateY(-7px) translateX(6px);
  }

  .cl-effect-8 .pic:hover::before,
  .cl-effect-8 .pic:focus::before {
    opacity: 0;
    transform: translateY(5px) translateX(-5px);
  }

  .cl-effect-8 .pic:hover::after,
  .cl-effect-8 .pic:focus::after  {
    opacity: 1;
    transform: translateY(0px) translateX(0px);
  }
  .userinfo_popover {
    overflow: hidden;
    padding-left:35px;
    padding-right: 45px;
    position: relative;
  }
  .userinfo_popover .avatar{
    background: #fff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid #eee;
    position: absolute;
    left:0px;
    top:0px;
  }
   ::-webkit-input-placeholder { /* placeloder 字体颜色 */
    color:#d2d2d2;
    font-size:14px;
    /* font-family:PingFangSC-Regular; */
    font-weight:normal;
  }
  .userinfo_popover .avatar img {
    width: 100%;
    display: block;
    border-radius: 50%;
  }
  .userinfo_popover div{
    line-height: 15px;
  }
  .userinfo_popover .txt{
    height: 40px;
  }
  .userinfo_popover .nickname {
    font-size: 12px;
    color: #737373;
  }
  .userinfo_popover .identity {
    font-size: 10px;
    color: #b3b3b3;
    -webkit-transform: scale(0.8);
    margin-left: -17px;
  }
  .userinfo_popover .limittime {
    color: #a7a7a7;
    margin-left: -30px;
    font-size: 12px;
  }
  .userinfo_popover .user_operation {
    color: #7ab3f6;
    margin-left: -30px;
    margin-bottom:10px;
    margin-top:10px;
    font-size: 12px;
    cursor: pointer;
  }
  .userinfo_popover .user_export {
    color: #505050;
    margin-left: -30px;
    margin-right:-50px;
    margin-bottom:10px;
    margin-top:10px;
    font-size: 12px;
    height:20px;
  }
  .userinfo_popover .user_recharge{
    position:absolute;
    display:inline-block;
    text-align:center;
    font-size:15px;
    margin-top:-5px;
    -webkit-transform:scale(0.8);
    right:0px;
   }
  .userinfo_popover .login-out {
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .class-qq-popover {
    overflow: hidden;
    position: relative;
  }
</style>

<style lang="stylus" scoped>
  .homepage
    position: absolute
    top: 0px
    right: 0
    bottom: 0
    left: 0
    background: #303030//#fff
    .menu-more-list
      width 150px
      background #f0f0f0
      position absolute
      z-index 100
      top 60px
      left 0
      .menu-more-list-item
        line-height: 30px
        text-align center
        color: #2f2f2f
        cursor: pointer
        &:hover
          background: #fff
          font-size 16px
    .nav
      overflow: hidden
      background: #303030//#f0f0f0
      height: 80px
      position: relative
      padding: 0 150px
      .menu
        text-align: center
        ul
          display: inline-flex
          padding-top: 0px
          li
            line-height: 60px
            margin: 0 15px
            padding: 0 30px
            font-size: 16px
            color: #fff//#2f2f2f
            cursor: pointer
            .board
              opacity: 0;
            &:hover{
              background:#5c5c5c
              .board{
                  opacity:1
                  background: url(./home_board_hover.png) no-repeat 50% 40%
              }
            }
          .active
            background:#ff4f53
            font-size:17px
            .board
              opacity:1
            &:hover{
              background:#ff4f53
              .board{
                  opacity:1
                  background: url(./home_board.png) no-repeat 50% 40%
              }
            }
          div
            background:yellow;
            width:50px;
            height:50px;
            position:absolute;
            margin:auto;
            top:0;
            left:0;
            bottom:-84px;
            right:0;
            background: url(./home_board.png) no-repeat 50% 40%
      .userinfo
        height: 60px
        position: absolute
        top: 0
        cursor pointer
      .logo
        left: 0
        top 15px
        height 30px
        margin-left 16px
        img
          height 30px
      .class-qq-icon
        position: absolute
        cursor: pointer
        right: 150px
        top: 0
        img
          fill: #333
          margin-top: 17px
          width: 26px
          height: 26px
      .class-vip-icon
        position: absolute
        cursor: pointer
        right: 118px
        top: 0
        img
          margin-top: 18px
          width: 24px
          height: 24px
          fill: #333
      .userinfo
        right: 10px
        div
          float: left
          line-height: 60px
        .nickname
          width: 50px
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          margin-top 0px
          color:#fff
        .limittime
          color #999
        .avatar
          background: #fff
          border-radius: 50%
          width: 40px
          height: 40px
          border: 1px solid #eee
          margin-top: 8px
          margin-right: 10px
          img
            width: 100%
            display: block
            border-radius: 50%
        .logout
          margin-left: 30px
          a
            border-radius: 3px
            padding: 5px 10px
            color: #fff
            background-color: #5cb85c
            border-color: #4cae4c
            cursor: pointer
            text-decoration: none

    .slidebar
      position: absolute
      top: 60px
      bottom: 0
      left: 0
      width: 180px
      background:#303030//#e8e8e8
      border-right:0.5px solid #000//#c7c7c7
      .menu
        div
          border-bottom: 0.5px solid #000//#c7c7c7
          background: #303030//#e8e8e8
          text-align: left//center
          height: 48px
          line-height: 48px
          color: #fff//#747474
          cursor: pointer
          font-size: 14px
          font-weight:normal
          &:hover{
            background:#5c5c5c
          }
        .status
          background: #222222//rgba(0,0,0,0.1)
          color:  #676767//#b9b9b9
        .left-icon
            width:20px;
            height:20px;
            top:14px;
            left:30px;
            float:left;
            display:block;
            &.ai
              background: url(./home_icon_ai.svg) no-repeat 50% 50%
              background-size: 20px 20px
            &.anim
              background: url(./home_icon_anim.png) no-repeat 50% 50%
            &.template
              background: url(./home_icon_template.png) no-repeat 50% 50%
            &.scene
              background: url(./home_icon_scene.png) no-repeat 50% 50%
            &.material
              background: url(./home_icon_image.png) no-repeat 50% 50%
            &.prop
              background: url(./home_icon_prop.png) no-repeat 50% 50%
            &.action
              background: url(./home_icon_action.png) no-repeat 50% 50%
            &.component
              background: url(./home_icon_module.png) no-repeat 50% 50%
            &.bgm
              background: url(./home_icon_music.png) no-repeat 50% 50%
            &.team
              background: url(./home_icon_team.png) no-repeat 50% 50%
            &.buy
              background: url(./home_icon_shop.png) no-repeat 50% 50%
        .active
          background: #fff//#747474
          color:#2f2f2f//#fff
          font-weight:bold
          &:hover{
            background: #fff
            color:#2f2f2f
          }
          .left-border
            background:#ff4f53;
            left:0px;
            width:3px;
            height:48px;
            position:absolute;
          .left-icon
            width:20px;
            height:20px;
            top:14px;
            left:30px;
            float:left;
            display:block;
            &.anim
              background: url(./home_icon_anim_active.png) no-repeat 50% 50%
            &.template
              background: url(./home_icon_template_active.png) no-repeat 50% 50%
            &.scene
              background: url(./home_icon_scene_active.png) no-repeat 50% 50%
            &.material
              background: url(./home_icon_image_active.png) no-repeat 50% 50%
            &.prop
              background: url(./home_icon_prop_active.png) no-repeat 50% 50%
            &.action
              background: url(./home_icon_action_active.png) no-repeat 50% 50%
            &.component
              background: url(./home_icon_module_active.png) no-repeat 50% 50%
            &.bgm
              background: url(./home_icon_music_active.png) no-repeat 50% 50%
            &.team
              background: url(./home_icon_team_active.png) no-repeat 50% 50%
            &.buy
              background: url(./home_icon_shop_active.png) no-repeat 50% 50%
          .left-title
            font-size: 14px
            font-weight:normal
        .left-title
            padding-left:65px
    .toolbar
      position: absolute
      top: 60px
      right: 0
      height: 36px
      left: 200px
      padding: 20px
      background:#303030//#fff
      z-index 100
      .left
        float: left
        .title
          font-size: 14px
          line-height: 34px
          color:#fff
      .right
        float: right
        margin-right: 20px
        .search
          position: relative
          padding-right: 35px
          display: inline-block
          float: left
          margin-right: 15px
          background:#fff
          border-radius: 5px
          .text
            border: 1px solid #bbb
            border-radius: 5px 0 0 5px
            width: 200px
            height: 34px
            padding: 0 30px 0 5px
            font-size: 14px
          .button
            position: absolute
            top 13px
            right 40px
            cursor pointer
            &:hover
              color: #717171
            &:active
              color: #4A4A4A
          .icon-search
            top: 0
            right: 0
            border: 1px solid #bbb
            border-radius: 0 5px 5px 0
            width: 34px
            height: 34px
            line-height: 34px
            text-align: center
            font-size: 32px
            color: #a1a1a1
            cursor: pointer
          .icon-x-altx-alt
            right: 50px
            top: 13px
        .button-group
          float: left
          span
            padding-right: 10px
            font-size:14px
            strong
              color:#f00

    .main
      position: absolute
      top: 136px
      right: 0
      bottom: 0
      left: 200px
      overflow: auto
      .loading
        position: absolute
        left: 50%
        top: 50%
        width: 100px
        height: 100px
        margin-top: -100px
        margin-left: -50px
      .inner
        padding: 0 20px
        .breadcrumb
          line-height: 30px
          margin-bottom: 10px
          span
            line-height: 30px
            display: inline-block
            padding-right: 5px
            color: #20a0ff
            cursor: pointer
        .list
          margin-top: 0
          overflow: hidden
          .item
            float: left
            // width: 180px
            margin-right: 20px
            margin-bottom: 20px
            cursor: pointer
            position: relative
            .el-checkbox
              position: absolute
              top: 10px
              left: 10px
              width: 20px
              overflow: hidden
              z-index: 1000
              .el-checkbox__label
                display none
            .pic
            //   width: 180px
              height: 120px
              border: 1px solid #747474//#dbdbdb
              position: relative
              overflow: hidden
              img
                // width: 180px
                // height: 120px
                display: block
                background-size:cover
                width:100%
                height:100%
              .duration
                position:absolute
                top:-5px
                right:-10px
                width:50px
                height:20px
                color:#fff
                font-size:12px
                background:rgba(0,0,0,0.4)
                padding:8px 2px 0px 3px
                -webkit-transform: scale(0.8);
              .folder-group
                position: absolute
                left: 0
                bottom: 0
                right: 0
                display: flex
                z-index: 1
                opacity: 0
                i
                  display: block
                  flex: 1
                  line-height: 30px
                  margin: 0
                  text-align: center
                  background: #3b3b3b//rgba(116, 116, 116, .9)
                  color: #fff
                  font-size 16px
                  &:hover
                    background: #494949
                    font-size 20px
                  &:active
                    background: #232323
                .icon-home_edit
                  font-size 26px
                  &:hover
                    background: #494949
                    font-size 30px
                  &:active
                    background: #232323
                .icon-home_aadd
                  font-size 26px
                  &:hover
                    background: #494949
                    font-size 30px
                  &:active
                    background: #232323
                .icon-home_uploading
                  font-size 26px
                  &:hover
                    background: #494949
                    font-size 30px
                  &:active
                    background: #232323
                .icon-home_template_save
                  font-size 26px
                  &:hover
                    background: #494949
                    font-size 30px
                  &:active
                    background: #232323
              .show
                opacity: 1
              .hide
                opacity: 0
            .folder
              img
                width: 80px
                height: 80px
                margin: 0 auto
                margin-top: 10px
                display: block
              .folder-material
                 margin-top: 40px
            .name,
            .date
              padding-top: 5px
              color: #e2e2e2//#3c3c3c
            .name
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              font-size:12px
            .date
              color: #9c9c9c//#999
              font-size:13px
              position:relative
              left:-27px
              top:0px
              -webkit-transform:scale(0.7)
            .date-material,
            .date-bgm
              left:-25px
              width:160px
            .anim-
              width:180px
            .material-
                width:121px
                height:161px
                .material-img-con
                    width:100%
                    height:100%
                    line-height:160px
                    text-align:center
                    .material-img
                        top:0
                        width:auto
                        height:auto
                        max-width:100%
                        max-height:100%
                        display: inline-block
                        vertical-align:middle
                    .material-img-vertical-default
                        width 161px
                        height 121px
            .bgm-
              width:120px
              height:120px
              .folder
              img
                margin-top: 0px
                padding:20px
              .pic
              img
                width:80px
                height:80px
                padding:20px
          .material-,
          .bgm-
            width:120px
          .anim-
            width:180px
          .list-action
               background:blue
               .group
               i
                color:#e2e2e2
               .folder-group
                position: absolute
                top:0
                left:0
                right:0
                display: flex
                z-index: 1
                opacity: 0
                i
                  display: block
                  flex: 1
                  line-height: 30px
                  margin: 0
                  text-align: center
                  background: #3b3b3b//rgba(116, 116, 116, .9)
                  color: #fff
                  font-size 16px
                  &:hover
                    background: #494949
                    font-size 20px
                  &:active
                    background: #232323
                .icon-home_edit
                  font-size 26px
                  &:hover
                    background: #494949
                    font-size 30px
                  &:active
                    background: #232323
            .name,
            .date
                padding-top: 8px
                color: #3c3c3c
            .name
                color:#e2e2e2
                overflow: hidden
                white-space: nowrap
                text-overflow: ellipsis
            .date
                color: #9c9c9c//#999
                font-size:13px
                position:relative
                left:-40px
                top:0px
                -webkit-transform:scale(0.7)
    .ai-image
        position: absolute
        top: 60px
        right: 0
        bottom: 0
        left: 200px
        overflow: auto
        .loading
            position: absolute
            left: 50%
            top: 50%
            width: 100px
            height: 100px
            margin-top: -100px
            margin-left: -50px
    .team_management
      position: absolute
      top: 136px
      right: 0
      bottom: 0
      left: 200px
      overflow: auto
      .loading
        position: absolute
        left: 50%
        top: 50%
        width: 100px
        height: 100px
        margin-top: -100px
        margin-left: -50px

    .team_add_edit
        position: absolute
        top: 60px
        right: 0
        bottom: 0
        left: 200px
        overflow: auto
        background:white
        .top
           position: absolute
           width:100%
           height:80px
           .back_btn
              position:absolute
              top:30px
            .title
              font-size:20px
              text-align:center
              vertical-align:middle
              width:500px
              height:50px
              margin: 10px auto
              margin-bottom :0px
              .p
                position:absolute
                height:25px
                width:500px
                margin:25px 0px 0px 0px
        .team_management_content
            position: relative
            width:500px
            top:80px
            margin: 10px auto
            background:#303030
        .team_management_save
            position: relative
            width:500px
            top:100px
            height:50px
            margin: 10px auto
            .team_save_btn
               position: relative
               width:300px
               height:35px
               margin-left:100px
    .pagination
      text-align: center
      background: #303030//#eee
      padding: 5px
      border-radius: 3px
      margin-bottom: 20px
    .dialog-delete
      .text
        line-height: 150%
        span
          color: #f00
    .bgm_info
      position relative
      padding-left 60px
      padding-top 5px
      box-sizing border-box
      .pic
        position  absolute
        width 50px
        height 50px
        left 0
        top 0
        img
          width 100%
      .bgm_title
        height 20px
        line-height 20px
      .bgm_copyright
        height 20px
        line-height 20px
    .bgm_play
      background #d8d8d8
      position relative
      padding-left 50px
      padding-right 150px
      height 40px
      border-radius 25px
      margin-top 10px
      .icon-play
        color #1e3255
        font-size 20px
        position absolute
        top 10px
        left 10px
        cursor pointer
      .icon-pause
        color #1e3255
        font-size 20px
        position absolute
        top 10px
        left 10px
        cursor pointer
      .time
        position absolute
        right 20px
        top 10px
    .no_permission
      position: absolute
      top: 230px
      right: 0
      bottom: 0
      left: 200px
      overflow: auto
      text-align: center;
      height: 48px;
      line-height: 48px;
      color: #747474;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
    .package_list_toorbar
      position: absolute
      top: 60px
      right: 0
      height: 36px
      left: 200px
      padding: 10px
      background:rgba(0,0,0,0.01)//#303030//#fff
      z-index 100
      .package_list_toorbar_left
        float: left
        font-size: 14px
        line-height: 34px
        color:#fff
      .package_list_toorbar_right
        float: right
        margin-right: 20px
        background:#fff
        border-radius:5px 0 0 5px
        .search
          position: relative
          display: inline-block
          float: left
          .text
            border: 1px solid #bbb
            border-radius: 5px 0 0 5px
            width: 200px
            height: 34px
            padding: 0 30px 0 5px
            font-size: 14px
          .button
            position: absolute
            top 13px
            right 40px
            cursor pointer
            &:hover
              color: #717171
            &:active
              color: #4A4A4A
          .icon-search
            top: 0
            right: 0
            border: 1px solid #bbb
            border-radius: 0 5px 5px 0
            width: 34px
            height: 34px
            line-height: 34px
            text-align: center
            font-size: 32px
            color: #a1a1a1
            cursor: pointer
          .icon-x-altx-alt
            right: 50px
            top: 13px
    .package_back
      position: absolute
      top: 60px
      right: 0
      height: 36px
      left: 200px
      padding: 10px 20px
      background #fff
      z-index 100
      cursor pointer
      line-height 36px
    .package
      position: absolute
      top: 90px
      right: 0
      bottom: 0
      left: 200px
      overflow: auto
      .package_back
        padding 0 10px
        cursor pointer
        background:green
      .package_list
        .package_list_data
          margin-top: 50px
          overflow: auto
          padding 0 20px
          .item
            float: left
            width: 180px
            margin-right: 20px
            margin-bottom: 20px
            cursor: pointer
            position: relative
            .pic
              width: 180px
              height: 120px
              border: 1px solid #747474//#dbdbdb
              position: relative
              overflow: hidden
              img
                width: 80px
                height: 80px
                padding:20px 50px 20px 50px
                display: block
            .title
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              margin-top 5px
              color:#fff
      .detail_list
        overflow hidden
        .package_detail_scene
          float: left
          width: 180px
          margin-right: 20px
          margin-bottom: 20px
          cursor: pointer
          position: relative
          .pic
              width: 180px
              height: 120px
              border: 1px solid #747474//#dbdbdb
              position: relative
              overflow: hidden
              img
                width: 180px
                height: 120px
                display: block
            .title
              width:180px
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              margin-top 4px
            .name
              height:20px
              width:120px
              font-size:12px
            .title,
            .name
              color:#fff
        .package_detail_material
          float: left
          width: 120px
          margin-right: 20px
          margin-bottom: 20px
          cursor: pointer
          position: relative
          .pic
              width: 120px
              height: 160px
              border: 1px solid #747474//#dbdbdb
              line-height:160px
              position: relative
              overflow: hidden
              text-align:center
              background:#fff
              img
                width:auto
                height:auto
                max-width:100%
                max-height:100%
                display: inline-block
                vertical-align:middle
            .title
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              margin-top 4px
            .name
              height:20px
              width:120px
              font-size:12px
            .title,
            .name
              color:#fff
        .package_detail_prop
          float: left
          width: 120px
          margin-right: 20px
          margin-bottom: 20px
          cursor: pointer
          position: relative
          .pic
              width: 120px
              height: 160px
              border: 1px solid #747474//#dbdbdb
              line-height:160px
              text-align:center
              position: relative
              overflow: hidden
              background:#fff
              img
                width:auto
                height:auto
                max-width:100%
                max-height:100%
                vertical-align:middle
                display:inline-block
            .title
              width:120px
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              margin-top 4px
            .name
              height:20px
              width:120px
              font-size:12px
            .title,
            .name
              color:#fff
        .package_detail_bgm
          float: left
          width: 120px
          margin-right: 20px
          margin-bottom: 20px
          cursor: pointer
          position: relative
          box-sizing border-box
          .pic
              width: 120px
              height: 120px
              border: 1px solid #747474//#dbdbdb
              position: relative
              overflow: hidden
              img
                width: 80px
                height: 80px
                padding:20px 20px 20px 20px
                background-size:cover
                // display: block
            .title
              width:120px
              overflow: hidden
              white-space: nowrap
              text-overflow: ellipsis
              margin-top 4px
            .name
              height:20px
              width:120px
              font-size:12px
            .title,
            .name
              color:#fff
        .package_detail_action
          width 260px
          height 40px
          line-height 40px
          background #f0f0f0
          float left
          margin-right: 20px
          margin-bottom: 20px

  .no_results
          .pic
            img
              margin 0 auto
              display block
          .text
            text-align center
            font-size 18px
            height 30px
            line-height 30px
            color:#e2e2e2
    .player
        position: absolute//relative
        padding-top: 0
        left: 0
        width: 100%
        height: 0
        padding-top:60%
        top:60px
        background:#000//#cccccc
        .line
            position: absolute
            width: 100%
            height: 0px
            background: #dddddd
        .playerContainer
            position: absolute
            width: 100%
            height: 100%
            left: 0
            top: 0
            right:0
            bottom:0
</style>


// WEBPACK FOOTER //
// HomePage.vue?2762e5aa